/* eslint-disable array-callback-return */
import _ from 'lodash';
import React,{ useState,useEffect,useRef } from 'react';
import dayjs from 'dayjs';
import moment from 'moment';
import '../../CSS/index.css';
import { connect } from 'react-redux';
import TrendSlider from './TrendSlider';
import RealTimeGraph from './RealTimeGraph';
import Highlighter from 'react-highlight-words';
import { ActionCheckbox } from '../../CSS/style';
import FunctionalSummary from './FunctionalSummary';
import ReactEcharts from '../../Utils/Echarts/Echarts';
import { actionList } from '../../../RuleEngine/utils/const';
import themeSettings from '../../../../commons/styles/themeSettings.json';
import StyledTable from '../../../../commons/styles/table';
import {
  Button,
  Checkbox,
  Form,
  Input,
  Popconfirm,
  Switch,
  Tabs,
  Tree,
  message,
  DatePicker,
  Space,
  Image,
  Tooltip,
  Col,
  Row,
  Card,
  Select,
  Typography,
  InputNumber,
  Drawer
} from 'antd';
import {
  DownOutlined,
  LineChartOutlined,
  SearchOutlined,
  SwapOutlined
} from '@ant-design/icons';
import {
  StyledForm,
  StyledModal,
  StyledSubForm,
  StyledBox,
  StyledBoxLabel,
  StyleModal
} from '../../CSS/style';
import {
  getMetaData,
  RegisterModel,
  DeployModel,
  getDeployHistory,
  getList,
  recipientList,
  getCommunicationList,
  RealTimeGraphData
} from '../../Utils/FormCalls';
import {
  RBSPREDMODEL,
  RBSLOOKUPMaster,
  API_TRENDS,
  GETUSERLIST,
  REALTIMEPREDICTION,
  MASTERDATASOURCE,
  IPAddress
} from '../../../../commons/api';
const { TreeNode } = Tree;
const { TextArea } = Input;
const { RangePicker } = DatePicker;
const { Option } = Select;
const { Title } = Typography;
const color = [
  'orange',
  'tomato',
  'steelblue',
  'green',
  'pink',
  'violet',
  'yellow',
  'red',
  'blue',
  'grey',
  'orange',
  'tomato',
  'steelblue',
  'green',
  'pink',
  'violet',
  'yellow',
  'red',
  'blue',
  'grey'
];
const ApiList = {
  getData: `${RBSPREDMODEL.ReadMetadata}`,
  insert: `${RBSPREDMODEL.RegisterModel}`,
  deployModel: `${IPAddress.PREDICTIONIP}/dep_reqs/create_request`,
  getDeployHistory: `${RBSPREDMODEL.DeployemtReqlist}`,
  getMetrics: `${RBSLOOKUPMaster.LookUpItemsGetById}`,
  updateDefaultStatus: `${IPAddress.PREDICTIONIP}/dep_reqs/update_default`,
  predictionRequest: `${IPAddress.PREDICTIONIP}/pred_reqs/create_request`,
  getPredictionHistory: `${RBSPREDMODEL.PredictionReqlist}`,
  getMetricResults: `${RBSPREDMODEL.MetricpRedList}`,
  getRealTimeMetricResults: `${IPAddress.PREDICTIONIP}/realtime/metric_calc`,
  getPredictionResults: `${RBSPREDMODEL.PredictionResList}`,
  getTagsByModelId: `${RBSPREDMODEL.RelatedTagsValuesList}`,
  getParameterByDevice: `${RBSPREDMODEL.DeviceParameters}`,
  generateTrend: `${API_TRENDS.LIST}`,
  getImageList: `${RBSPREDMODEL.PredictImages}`,
  getUsersList: `${GETUSERLIST.GET}`,
  functionalSummaryForMonthly: `${RBSPREDMODEL.FunctionalSummaryWeek}`,
  functionalSummaryForDaily: `${RBSPREDMODEL.FunctionalSummaryDayWise}`,
  realTimeFunctionalSummaryForMonthly: `${REALTIMEPREDICTION.RealTimeFunctionalSummaryWeek}`,
  realTimeFunctionalSummaryForDaily: `${REALTIMEPREDICTION.RealTimeFunctionalSummaryDayWise}`,
  getDataSourceList: `${MASTERDATASOURCE.DatasourceList}`,
  realTimeCreate: `${IPAddress.PREDICTIONIP}/realtime/create_request`,
  realTimeStop: `${IPAddress.PREDICTIONIP}/pm2/stop_pm2`,
  getRealTimePredList: `${REALTIMEPREDICTION.RealTimePredictionList}`,
  getRealTimePredictionResults: `${REALTIMEPREDICTION.RealTimePredictionResList}`,
  realTimeConditionsCreate: `${REALTIMEPREDICTION.Create}`,
  getAnalyticsActionsLog: `${REALTIMEPREDICTION.GetAnalyticsActionLogs}`,
  actionsGetById: `${REALTIMEPREDICTION.Get}`,
  getQuickrunResults: `${REALTIMEPREDICTION.GetQuickRunResult}`
};
const intervalData = [
  {
    key: '1Min',
    value: '1m'
  },
  {
    key: '15Min',
    value: '15m'
  },
  {
    key: '30Min',
    value: '30m'
  },
  {
    key: '60Min',
    value: '1h'
  },
  {
    key: 'Day',
    value: '1d'
  }
];
const ModelDetails = (props) => {
  const [formObject, setFormObject] = useState({});
  const [modelVisible, setModelVisible] = useState(false);
  const [functionalSummaryDailyTo, setFunctionalSummaryDailyTo] = useState([]);
 // const [metricResultVisible, setMetricResultVisible] = useState(false);
 const [dailyFunctionalSummary, setDailyFunctionalSummary] = useState([]);
  const [disableGraph, setDisableGraph] = useState(false);
  const [recordId, setRecordId] = useState([]);
  //const [addCondition, setAddCondition] = useState(false);
  const [actionRecordPredReqId, setActionRecordPredReqId] = useState([]);
  const [status, setStatus] = useState('Inactive');
  const [mailRecipient, setMailRecipient] = useState([]);
  //const [usersList, setUsersList] = useState([]);
  const [selectedCommunication, setSelectedCommunication] = useState([]);
  const [modelDeployHistoryData, setModelDeployHistoryData] = useState([]);
  const [trendObj, setTrendObj] = useState([]);
  const [deployModelVisible, setDeployModelVisible] = useState(false);
  const [modelDeploymentInfo, setModelDeploymentInfo] = useState({});
  const [deviceList, setDeviceList] = useState([]);
  const [userProfile, setUserProfile] = useState(props.userProfile || {});
  const [difMin, setDifMin] = useState([]);
  const [modelPredHistoryData, setModelPredHistoryData] = useState([]);
  const [differenceHours, setDifferenceHours] = useState([]);
  const [momentRange, setMomentRange] = useState([
    moment(moment().subtract(60, 'minute').format('YYYY-MM-DD HH:mm:ss')),
    moment(moment().add(15, 'minute').format('YYYY-MM-DD HH:mm:ss'))
  ]);
  const [functionalSummaryDailyFrom, setFunctionalSummaryDailyFrom] = useState([]);
  const [selectionDateRange, setSelectionDateRange] = useState({
    startDate: moment().subtract(60, 'minute').format('YYYY-MM-DD HH:mm'),
    endDate: moment().add(15, 'minute').format('YYYY-MM-DD HH:mm'),
    timeBucket: '1m'
  });
  // functionalSummaryFrom:moment().subtract(60, 'minute').format('YYYY-MM-DD HH:mm'),
  // functionalSummaryTo:moment().add(15, 'minute').format('YYYY-MM-DD HH:mm'),
  // OnValueChangeDisable: true,
  const [predictionResultsData, setPredictionResultsData] = useState([]);
  const [weeklyFunctionalSummary1, setWeeklyFunctionalSummary1] = useState([]);
  const [realPredictionResultsData, setRealPredictionResultsData] = useState([]);
  const [functionalSummaryWeekCount1, setFunctionalSummaryWeekCount1] = useState([]);
  const [predResInfo, setPredResInfo] = useState({});
  const [functionalSummaryWeeklyTo1, setFunctionalSummaryWeeklyTo1] = useState([]);
  const [weeklyFunctionalSummary, setWeeklyFunctionalSummary] = useState([]);
  const [functionalSummaryWeekCount, setFunctionalSummaryWeekCount] = useState([]);
  const [functionalSummaryWeeklyTo, setFunctionalSummaryWeeklyTo] = useState([]);
  const [metricValuesData, setMetricValuesData] = useState([]);
  const [metricImagesData, setMetricImagesData] = useState([]);
  //let metricResultData = [];
  //const [rocCurveData, setROCCurveData] = useState([]);
  const [predictionModel, setPredictionModel] = useState(false);
  const [predictionFromTime, setPredictionFromTime] = useState([]);
  const [realTimeModel, setRealTimeModel] = useState(false);
  const [predictionToTime, setPredictionToTime] = useState([]);
  const [realTimePredictionReqInfo, setRealTimePredictionReqInfo] = useState([]);
  const [realTimeFunctionalSummary, setRealTimeFunctionalSummary] = useState([]);
  const [quickRunModal, setQuickRunModal] = useState(false);
  const [dataSourceId, setDataSourceId] = useState([]);
  //const [actionsModel, setActionsModel] = useState(false);
  const [quickRunInfo, setQuickRunInfo] = useState([]);
  const [resultsDrawerVisible, setResultsDrawerVisible] = useState(false);
  const [predictionReqInfo, setPredictionReqInfo] = useState([]);
  const [realTimeResultsDrawerVisible, setRealTimeResultsDrawerVisible] = useState(false);
  const [metricValuesData1, setMetricValuesData1] = useState([]);
  const [realTimeQuickRunResultDrawer, setRealTimeQuickRunResultDrawer] = useState(false);
  const [actionsLogDataSource, setActionsLogDataSource] = useState([]);
  const [realTimePredResInfo, setRealTimePredResInfo] = useState({});
  const [value, setValue] = useState([]);
  const [metricsData, setMetricsData] = useState([]);
  const [value1, setValue1] = useState([]);
  const [predictionActiveKey, setPredictionActiveKey] = useState('Metric values');
  const [value2, setValue2] = useState([]);
  const [translationCache, setTranslationCache] = useState(props.translationCache || {});
  const [searchText, setSearchText] = useState([]);
  const [predictionRequestInfo, setPredictionRequestInfo] = useState({});
  const [searchedColumn,setSearchedColumn] = useState([]);
  const [realTimePredictionRequestInfo, setRealTimePredictionRequestInfo] = useState({});
  const [functionalSummaryTo,setFunctionalSummaryTo] = useState([]);
  //const [functionalSummaryFrom,setFunctionalSummaryFrom] = useState([]);
  const [realTimeInfo, setRealTimeInfo] = useState({});
  //const [actionInfo, setActionInfo] = useState({});
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10
  });
  const [parameterList, setParameterList] = useState([]);
  const [dailyFunctionalSummary1, setDailyFunctionalSummary1] = useState([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [functionalSummaryDailyFrom1, setFunctionalSummaryDailyFrom1] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [modelType, setModelType] = useState([]);
  const [realTimeVal, setRealTimeVal] = useState(false);
  const [modelName, setModelName] = useState([]);
  const [buttonKey, setButtonKey] = useState(null);
  const [functionalSummaryDailyTo1, setFunctionalSummaryDailyTo1] = useState([]);
  const [dataSourceList, setDataSourceList] = useState([]);
  //const [metricResultVisible, setMetricResultVisible] = useState([]);
  const [selectedCondition, setSelectedCondition] = useState([]);
  const [confMatrixVisible, setConfMatrixVisible] = useState(false);
  const [rocCurveVisible, setROCCurveVisible] = useState(false);
  const [realTimeMetricResultVisible, setRealTimeMetricResultVisible] = useState(false);
  const [recipientlist, setRecipientList] = useState([]);
  const [communicationType, setCommunicationType] = useState([]);
  const [data, setData] = useState([]);
  const [modelPredRealtimeHistoryData, setModelPredRealtimeHistoryData] = useState([]);
  const [selectedDeviceParameter, setSelectedDeviceParameter] = useState([]);
  const [option, setOption] = useState({});
  const [trendData, setTrendData] = useState([]);
  const [rocCurveOption, setRocCurveOption] = useState({});
 // const [graphType, setGraphType] = useState(props.panelData && props.panelData.type ? props.panelData.type : 'heatmap');
  const modelRef = useRef();
  const modelDeployRef = useRef();
  const predictionRequestRef = useRef();
  const buttonRef = useRef();
  const predictionButtonRef = useRef();
  const predResRef = useRef();
  //const taskRef = useRef();
  const trendRef = useRef();
  const searchInput = useRef(null);
  const realTimeTrendRef = useRef();
  const realTimeModelRef = React.createRef();
  const realTimePredResRef = useRef();
  const realTimePredictionRequestRef = useRef();
  //const actionsModalRef = useRef();
  const quickRunModalRef = useRef();
  const quickRunResultsRef = useRef();
  const translation = (keyword) => {
    let { translationCache } = props;
    return translationCache && translationCache[keyword] ? translationCache[keyword] : keyword;
  };
  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInput}
          placeholder={translation('Search') + translation(dataIndex)}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
          icon={<SearchOutlined />}
          
          style={{
            width: 90,
            marginRight: '5px'
          }}
        >
          {translation('Search')}
        </Button>
        <Button
          type='primary' danger
          onClick={() => clearFilters && handleReset(clearFilters, confirm)}
          
          style={{ width: 90 }}
        >
          {translation('Reset')}
        </Button>
        {/* <Button
          type="link"
          
          onClick={() => {
            confirm({
              closeDropdown: false,
            });
            setState({
              searchText: selectedKeys[0],
              searchedColumn: dataIndex,
            });
          }}
        >
          Filter
        </Button> */}
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex] && record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current.select());
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text.toString()}
        />
      ) : (
        text
      )
  });
  const predictionCLFResultColumns = [
    {
      title: translation('Current Time'),
      dataIndex: 'CurrentTime',
      hide: true,
      key: 'CurrentTime',
      ...getColumnSearchProps('CurrentTime'),
      sorter: (a, b) =>
        a.CurrentTime && b.CurrentTime && a.CurrentTime.localeCompare(b.CurrentTime),
      render: (text) => ({
        children: text !== undefined ? (
          <div>{moment(text).utc().local().format('YYYY-MM-DD HH:mm:ss')}</div>
        ) : null
      })
    },
    {
      title: translation('Predicted From'),
      dataIndex: 'predTimeFrom',
      key: 'predTimeFrom',
      ...getColumnSearchProps('predTimeFrom'),
      sorter: (a, b) =>
        a.predTimeFrom && b.predTimeFrom && a.predTimeFrom.localeCompare(b.predTimeFrom),
      render: (text) => ({
        children: text !== undefined ? (
          <div>{moment(text).utc().local().format('YYYY-MM-DD HH:mm:ss')}</div>
        ) : null
      })
    },
    {
      title: translation('Predicted To'),
      dataIndex: 'predTimeTo',
      key: 'predTimeTo',
      ...getColumnSearchProps('predTimeTo'),
      sorter: (a, b) =>
        a.predTimeTo && b.predTimeTo && a.predTimeTo.localeCompare(b.predTimeTo),
        render: (text) => {
          return {
            children:
              text !== undefined ? (
                <div>{moment(text).utc().local().format('YYYY-MM-DD HH:mm:ss')}</div>
              ) : null
          };
        }
    },
    {
      title: translation('Predicted Status'),
      dataIndex: 'PredictedStatus',
      key: 'PredictedStatus',
      filters: [
        {
          text: translation('NORMAL'),
          value: 'NORMAL'
        },
        {
          text: translation('ABNORMAL'),
          value: 'ABNORMAL'
        }
      ],
      onFilter: (value, record) => record.PredictedStatus === value
    },
    {
      title: translation('Actual Status'),
      dataIndex: 'ActualStatus',
      key: 'ActualStatus',
      filters: [
        {
          text: translation('NORMAL'),
          value: 'NORMAL'
        },
        {
          text: translation('ABNORMAL'),
          value: 'ABNORMAL'
        }
      ],
      onFilter: (value, record) => record.ActualStatus === value
    },
    {
      title: translation('View Trends'),
      render: (record) => (
        <Tooltip title={translation('Trends')}>
          <Button
            data-testid={'lift-hold-button'}
            style={{ marginRight: '5px' }}
            onClick={() => {
              let trendObj = trendRef.current && trendRef.current.getFieldsValue();
              let CurrentTime = moment.utc(record.CurrentTime, 'YYYY-MM-DD HH:mm:ss');
              let fromDate = moment(CurrentTime).subtract(1, 'hours').format('YYYY-MM-DD HH:mm:ss');
              let toDate = moment(CurrentTime).add(1, 'hours').format('YYYY-MM-DD HH:mm:ss');
              let defaultParameter = [];
              if (Array.isArray(parameterList)) {
                parameterList.forEach((item, index) => {
                  if (index < 5) {
                    defaultParameter.push(item.parameterCode);
                  }
                });
              }
              trendObj = {
                ...trendObj,
                DeviceCode: (deviceList && deviceList[0] && deviceList[0]['Device']) ? [deviceList[0]['Device']] : [],
                ParameterCode: defaultParameter,
                FromDate: moment.utc(fromDate, 'YYYY-MM-DD HH:mm:ss').local(),
                ToDate: moment.utc(toDate, 'YYYY-MM-DD HH:mm:ss').local(),
                CurrentTime: moment.utc(CurrentTime, 'YYYY-MM-DD HH:mm:ss').local(),
                PredictionTargetFrom: moment(CurrentTime).utc().local().add(
                  formObject && formObject.FuturePredRangeFrom,
                  'minutes'
                ).format('DD-MM-YYYY HH:mm:ss'),
                PredictionTargetTo: moment(CurrentTime).utc().local().add(
                  formObject && formObject.FuturePredRangeTo,
                  'minutes'
                ).format('DD-MM-YYYY HH:mm:ss'),
                Interval: (intervalData && intervalData[0] && intervalData[0]['value']) ? intervalData[0]['value'] : ''
              };
              onParameterChange(defaultParameter);
              trendRef.current && trendRef.current.setFieldsValue(trendObj);
              setTrendObj(trendObj);
              setPredictionActiveKey('Trends');
            }}
            
          >
            <span>
              <LineChartOutlined />
            </span>
          </Button>
        </Tooltip>
      )
    }
  ];
  const predictionREGResultColumns = [
    {
      title: translation('Current Time'),
      dataIndex: 'CurrentTime',
      hide: true,
      key: 'CurrentTime',
      ...getColumnSearchProps('CurrentTime'),
      sorter: (a, b) =>
        a.CurrentTime && b.CurrentTime && a.CurrentTime.localeCompare(b.CurrentTime),
      render: (text) => ({
        children: text !== undefined ? (
          <div>{moment(text).utc().format('YYYY-MM-DD HH:mm:ss')}</div>
        ) : null
      })
    },
    {
      title: translation('Predicted From'),
      dataIndex: 'predTimeFrom',
      key: 'predTimeFrom',
      ...getColumnSearchProps('predTimeFrom'),
      sorter: (a, b) =>
        a.predTimeFrom && b.predTimeFrom && a.predTimeFrom.localeCompare(b.predTimeFrom),
      render: (text) => ({
        children: text !== undefined ? (
          <div>{moment(text).utc().format('YYYY-MM-DD HH:mm:ss')}</div>
        ) : null
      })
    },
    {
      title: translation('Predicted To'),
      dataIndex: 'predTimeTo',
      key: 'predTimeTo',
      ...getColumnSearchProps('predTimeTo'),
      sorter: (a, b) =>
        a.predTimeTo && b.predTimeTo && a.predTimeTo.localeCompare(b.predTimeTo),
      render: (text) => ({
        children: text !== undefined ? (
          <div>{moment(text).utc().format('YYYY-MM-DD HH:mm:ss')}</div>
        ) : null
      })
    },
    {
      title: translation('Predicted Value'),
      dataIndex: 'PredictedValue',
      key: 'PredictedValue'
    },
    {
      title: translation('Actual Value'),
      dataIndex: 'ActualValue',
      key: 'ActualValue'
    },
    {
      title: translation('View Trends'),
      render: () => (
        <Tooltip title={translation('Trends')}>
          <Button
            type='primary'
            data-testid={'lift-hold-button'}
            style={{ marginRight: '5px' }}
            
          >
            <span>
              <LineChartOutlined />
            </span>
          </Button>
        </Tooltip>
      )
    }
  ];
  useEffect(() => {
    const fetchData = async () => {
      let pathname = props.location.pathname;
      let metaData = {};
      let deviceList = [];
      if (pathname.includes('RegisterModel')) {
        let path = props.location.pathname.split('/rubus/RbsAnalytics/RegisterModel/');
        metaData = await getMetaData(ApiList.getData, 'ModelName', path[1]);
      } else {
        let path1 = props.location.pathname.split('/rubus/RbsAnalytics/ModelDetails/');
        metaData = await getMetaData(ApiList.getData, 'ModelId', path1[1]);
        _.cloneDeepWith(metaData, (value) => {
          return value !== null && value !== undefined
            ? {
                ...value,
                ...(value['TrainPeriodFrom']
                  ? (value['TrainPeriodFrom'] = moment(value.TrainPeriodFrom)
                      .utc()
                      .format('YYYY-MM-DD HH:mm:ss'))
                  : null),
                ...(value['TrainPeriodTo']
                  ? (value['TrainPeriodTo'] = moment(value.TrainPeriodTo)
                      .utc()
                      .format('YYYY-MM-DD HH:mm:ss'))
                  : null),
                ...(value['EvalPeriodFrom']
                  ? (value['EvalPeriodFrom'] = moment(value.EvalPeriodFrom)
                      .utc()
                      .format('YYYY-MM-DD HH:mm:ss'))
                  : null),
                ...(value['EvalPeriodTo']
                  ? (value['EvalPeriodTo'] = moment(value.EvalPeriodTo)
                      .utc()
                      .format('YYYY-MM-DD HH:mm:ss'))
                  : null),
                ...(value['CreatedTime']
                  ? (value['CreatedTime'] = moment(value.CreatedTime)
                      .utc()
                      .local()
                      .format('YYYY-MM-DD HH:mm:ss'))
                  : null)
              }
            : _.noop();
        });
        await getDeployHistory();
        await getPredictionHistory();
        let modelType =
          metaData && metaData.ModelType === 'Classification'
            ? 'RBS_MODEL_CLF_METRICS'
            : modelRef.current && modelRef.current.getFieldValue('ModelType') === 'Regression'
            ? 'RBS_MODEL_REG_METRICS'
            : null;
        var metricsData = await getDeployHistory(ApiList.getMetrics, 'LookupName', modelType);
        let modelId = metaData && metaData.ModelId ? metaData.ModelId : '';
        deviceList = await getDeployHistory(ApiList.getTagsByModelId, 'ModelId', modelId);
        let device =
          deviceList && deviceList[0] && deviceList[0]['Device'] ? [deviceList[0]['Device']] : [];
        let payload = {
          DeviceCode: device,
          ModelId: metaData && metaData.ModelId ? metaData.ModelId : ''
        };
        let response = await RegisterModel(ApiList.getParameterByDevice, payload);
        setParameterList(response && response.data && response.data.Operational ? response.data.Operational : []);
      }
      modelRef.current && modelRef.current.setFieldsValue(metaData);
      const recipientData = await recipientList();
      let commlist = await getCommunicationList();
    // {
    //   data: [
    //     {
    //       Id: 1,
    //       SiteId: 1,
    //       Name: 'Email',
    //       Code: 'Email',
    //       Status: true
    //     },
    //     {
    //       Id: 2,
    //       SiteId: 1,
    //       Name: 'Slack',
    //       Code: 'Slack',
    //       Status: true
    //     }
    //   ]
    // };
      let communicationType =
        commlist &&
        commlist.data &&
        Array.isArray(commlist.data) &&
        commlist.data.map((item) => item.Code);
      setCommunicationType(communicationType);
      const startDate = momentRange[0];
      const timeEnd = momentRange[1];
      const diff = timeEnd.diff(startDate);
      const diffDuration = moment.duration(diff);
      let differenceHours = diffDuration.days();
      let difMin = Math.round((timeEnd - startDate) / 1000 / 60);
      setDifferenceHours(differenceHours);
      setDifMin(difMin);
      let filteredActionList = getList1();
      let dataSourceList = await getList(ApiList.getDataSourceList);
      let modelPredRealtimeHistoryData = [];
      if (!pathname.includes('RegisterModel')) {
        let path1 = props.location.pathname.split('/rubus/RbsAnalytics/ModelDetails/');
        modelPredRealtimeHistoryData = await getDeployHistory(
          ApiList.getRealTimePredList,
          'ModelId',
          path1[1]
        );
      }
    // getRealTimeHistory();
      let data =
        modelPredRealtimeHistoryData &&
        Array.isArray(modelPredRealtimeHistoryData) &&
        modelPredRealtimeHistoryData.filter(
          (item) =>
            item.Status === 'Scheduled' || item.Status === 'Initiated' || item.Status === 'Running'
        ).length === 0
          ? false
          : true;
      setRecipientList(recipientData && recipientData.data ? recipientData.data : []);
      setModelType(metaData && metaData.modelType);
      setModelName(metaData && metaData.modelName);
      setFormObject(metaData);
      setMetricsData(metricsData);
      setDeviceList(deviceList);
      setRealTimeVal(data);
      setDataSourceList(dataSourceList);
      setModelPredRealtimeHistoryData(modelPredRealtimeHistoryData);
      setRealTimeInfo(realTimeInfo);
      setData(filteredActionList);
    };
    fetchData();
  }, [props.location.pathname, momentRange]); 
  const getList1 = () => {
    let filteredArray = communicationType &&
    Array.isArray(communicationType) &&
    communicationType !== undefined &&
    communicationType.map((comm) => {
      return actionList.filter((action) => action.value === comm);
    });
    let data = [];
    filteredArray &&
    Array.isArray(filteredArray) &&
    filteredArray !== undefined &&
    filteredArray.map((item) => {
      data.push(...item);
    });
    return data;
  };
  const realTimeEdit = async (record, key) => {
    let recordData = await getMetaData(ApiList.actionsGetById, 'PredReqId', record.PredReqId);
    if (recordData && recordData[0]) {
      const realTimeInfo = {
        ...realTimeInfo,
        FromTime: dayjs(recordData[0].FromTime),
        ToTime: dayjs(recordData[0].ToTime),
        DataSourceID: record.DataSourceID,
        Comments: recordData[0].Comments,
        TargetServer: recordData[0].TargetServer,
        Frequency: recordData[0].Frequency,
        ModelName: recordData[0].ModelName,
        ModelType: recordData[0].ModelType,
        Operator: recordData[0].Operator,
        Value: recordData[0].Value,
        CommunicationTypes: recordData[0].CommunicationTypes,
        MailRecipient: recordData[0].MailRecipient,
        Status: recordData[0].Status
      };
      realTimeModelRef.current &&
        realTimeModelRef.current.setFieldsValue({
          FromTime: dayjs(recordData[0].FromTime),
          ToTime: dayjs(recordData[0].ToTime),
          DataSourceID: record && record.DataSourceID,
          TargetServer: recordData[0] && recordData[0].TargetServer,
          Frequency: recordData[0] && recordData[0].Frequency,
          Comments: recordData[0].Comments,
          ModelName: recordData[0].ModelName,
          ModelType: recordData[0].ModelType,
          Operator: recordData[0].Operator,
          Value: recordData[0].Value,
          CommunicationTypes: recordData[0].CommunicationTypes,
          MailRecipient: recordData[0].MailRecipient,
          Status: recordData[0].Status
        });
      setRealTimeInfo(realTimeInfo);
      await getRealTimeRefreshHistory(); 
      setRealTimeModel(true);
        setRealTimeInfo(realTimeInfo);
      setButtonKey(key);
      setSelectedCommunication(realTimeInfo.CommunicationTypes);
      setMailRecipient(realTimeInfo.MailRecipient);
      setSelectedCondition(recordData[0].Operator);
      setStatus(recordData[0].Status);
      setActionRecordPredReqId(recordData[0].PredReqId);
      setRecordId(recordData[0].Id);
    }
  };
  const realTimeStopJob = async (record, key) => {
    let recordData = await getMetaData(ApiList.actionsGetById, 'PredReqId', record.PredReqId);
    if (recordData && recordData[0]) {
      const RealTimeInfo = {
        ...realTimeInfo,
        FromTime: dayjs(recordData[0].FromTime),
        ToTime: dayjs(recordData[0].ToTime),
        DataSourceID: record.DataSourceID,
        TargetServer: recordData[0].TargetServer,
        Frequency: recordData[0].Frequency,
        Comments: recordData[0].Comments,
        ModelName: recordData[0].ModelName,
        ModelType: recordData[0].ModelType,
        Operator: recordData[0].Operator,
        Value: recordData[0].Value,
        CommunicationTypes: recordData[0].CommunicationTypes,
        MailRecipient: recordData[0].MailRecipient,
        Status: recordData[0].Status,
        PredReqId: recordData[0].PredReqId
      };
     realTimeModelRef.current &&
       realTimeModelRef.current.setFieldsValue({
          FromTime: dayjs(recordData[0].FromTime),
          ToTime: dayjs(recordData[0].ToTime),
          DataSourceID: record && record.DataSourceID,
          TargetServer: recordData[0] && recordData[0].TargetServer,
          Frequency: recordData[0] && recordData[0].Frequency,
          Comments: recordData[0].Comments,
          ModelName: recordData[0].ModelName,
          ModelType: recordData[0].ModelType,
          Operator: recordData[0].Operator,
          Value: recordData[0].Value,
          CommunicationTypes: recordData[0].CommunicationTypes,
          MailRecipient: recordData[0].MailRecipient,
          Status: recordData[0].Status
        });
      setRealTimeInfo(RealTimeInfo);
      setRealTimeModel(true);
      setButtonKey(key);
      setSelectedCommunication(realTimeInfo.CommunicationTypes);
      setMailRecipient(realTimeInfo.MailRecipient);
      setSelectedCondition(recordData[0].Operator);
      setStatus(recordData[0].Status);
    }
  };
  const onRealTimeModelStopJob = async () => {
    let payload = {
      PredReqId: realTimeInfo.PredReqId
    };
    let response = await DeployModel(ApiList.realTimeStop, payload);
    message.success(response && response.message && translation(response.message)); // Ensure translation function is defined
    realTimeModelRef.current && realTimeModelRef.current.setFieldsValue({
      FromTime: dayjs(),
      ToTime: null,
      DataSourceID: null,
      TargetServer: null,
      Frequency: null,
      Comments: null,
      ModelType: modelType, 
      ModelName: modelName, 
      Operator: null,
      Value: null,
      CommunicationTypes: [],
      MailRecipient: [],
      Status: 'Inactive'
    });
    await getRealTimeRefreshHistory(); 
    setRealTimeModel(false);
    setRealTimeInfo({});
    setSelectedCommunication([]);
    setMailRecipient([]);
    setSelectedCondition(null);
    setStatus('Inactive');
  };
//  const onRealTimeModelReqCancel = () => {
//     realTimeModelRef.current &&
//       realTimeModelRef.current.setFieldsValue({
//         FromTime: null,
//         ToTime: null,
//         DataSourceID: '',
//         Comments: ''
//       });
//     setRealTimeModel(false);
//     setRealTimeInfo({});
//   };
  const getDailyFunctionalSummary = async (functionalSummaryDailyFrom, functionalSummaryDailyTo) => {
    let payload = {
      PredReqId: predResInfo.PredReqId,
      siteId: '1',
      startDate: moment(functionalSummaryDailyFrom).utc().format('YYYY-MM-DD HH:mm:ss'),
      endDate: moment(functionalSummaryDailyTo).utc().format('YYYY-MM-DD HH:mm:ss')
    };
    let response = await DeployModel(ApiList.functionalSummaryForDaily, payload);
    if (response && Array.isArray(response) && response.length === 0) {
      message.info(translation('No Data')); 
    }
    setDailyFunctionalSummary(response || []);
    setFunctionalSummaryDailyFrom(functionalSummaryDailyFrom);
    setFunctionalSummaryDailyTo(functionalSummaryDailyTo);
  };
  const getRealTimeDailyFunctionalSummary = async (functionalSummaryDailyFrom1, functionalSummaryDailyTo1) => {
    let payload = {
      PredReqId: realTimeInfo.PredReqId,
      // siteId: '1',
      startDate: moment(functionalSummaryDailyFrom1).utc().format('YYYY-MM-DD HH:mm:ss'),
      endDate: moment(functionalSummaryDailyTo1).utc().format('YYYY-MM-DD HH:mm:ss')
    };
    let response = await DeployModel(ApiList.realTimeFunctionalSummaryForDaily, payload);
    if (response && Array.isArray(response) && response.length === 0) {
      message.info(translation('No Data'));
    }
    setDailyFunctionalSummary1(response || []);
    setFunctionalSummaryDailyFrom1(functionalSummaryDailyFrom1);
    setFunctionalSummaryDailyTo1(functionalSummaryDailyTo1);
  };
  const getRealTimeweeklyFunctionalSummary = async (functionalSummaryWeeklyTo1, functionalSummaryWeekCount1) => {
    let payload = {
      PredReqId: realTimePredResInfo.PredReqId,
      // siteId: '1',
      numberOfWeeks: functionalSummaryWeekCount1,
      Date: dayjs(functionalSummaryWeeklyTo1).utc().format('YYYY-MM-DD HH:mm:ss')
    };
    let response = await DeployModel(ApiList.realTimeFunctionalSummaryForMonthly, payload);
    if (response && Array.isArray(response) && response.length === 0) {
      message.info(translation('No Data')); 
    }
    setWeeklyFunctionalSummary1(response || 'undefined');
    setFunctionalSummaryWeekCount1(functionalSummaryWeekCount1);
    setFunctionalSummaryWeeklyTo1(functionalSummaryWeeklyTo1);
  };
  const getweeklyFunctionalSummary = async (functionalSummaryWeeklyTo, functionalSummaryWeekCount) => {
    let payload = {
      PredReqId: predResInfo.PredReqId,
      siteId: '1',
      numberOfWeeks: functionalSummaryWeekCount,
      Date: moment(functionalSummaryWeeklyTo).utc().format('YYYY-MM-DD HH:mm:ss')
    };
    let response = await DeployModel(ApiList.functionalSummaryForMonthly, payload);
    if (response && Array.isArray(response) && response.length === 0) {
      message.info(translation('No Data')); 
    }
    setWeeklyFunctionalSummary(response || []);
    setFunctionalSummaryWeekCount(functionalSummaryWeekCount);
    setFunctionalSummaryWeeklyTo(functionalSummaryWeeklyTo);
  };
  useEffect(() => {
    if (
      props.userProfile !== userProfile ||
      props.translationCache !== translationCache
    ) {
      setUserProfile(props.userProfile);
      setTranslationCache(props.translationCache);
    }
  }, [props.userProfile, props.translationCache]);
  // const getUsersList = async () => {
  //   let usersList = await getList(ApiList.getUsersList);
  //   setUsersList(usersList);
  // };
  const renderTree = (data) => {
    let array = [];
    data &&
      Object.keys(data).forEach((i) => {
        let newData = {
          key: i,
          children: data[i].map((j) => {
            return { key: j };
          })
        };
        array.push(newData);
      });
    return array;
  };
  const renderTreeNodes = (data) => {
    return (
      data &&
      Array.isArray(data) &&
      data.map((item) => {
        if (item.children && item.children.length > 0) {
          return (
            <TreeNode title={item.key} key={item.key} dataRef={item.key}>
              {renderTreeNodes(item.children,item)}
            </TreeNode>
          );
        }
        return <TreeNode key={item.value} title={item.key} dataRef={item.value} />;
      })
    );
  };
  const onFormSubmit = () => {
    modelRef.current
      .validateFields()
      .then(async (values) => {
        values = {
          ...modelRef.current.getFieldsValue()
        };
        let response = await RegisterModel(ApiList.insert, values);
        if (response && response.status === 200) {
          const Id = response.data && response.data['ModelId'] ? response.data['ModelId'] : null;
          let metaData = await getMetaData(ApiList.getData, 'ModelId', Id);
          modelRef.current && modelRef.current.setFieldsValue(metaData);
          setFormObject(metaData);
          message.success(`${formObject['ModelName']} Updated successfully`);
          props.navigate('/rubus/RbsAnalytics/ModelsWorkbench');
        }
      })
      .catch(() => { });
  };
  const onDeploySubmit = () => {
    modelDeployRef.current.validateFields().then(async (values) => {
      values = {
        ...modelDeployRef.current.getFieldsValue(),
        ModelId: formObject && formObject.ModelId ? formObject.ModelId : '',
        UserId: props.userProfile && props.userProfile.user && props.userProfile.user.Id ? props.userProfile.user.Id : ''
      };
      let response = await DeployModel(ApiList.deployModel, values);
      message.success(response && response.message && translation(response.message)); // Ensure translation function is defined
      let path1 = props.location.pathname.split('/rubus/RbsAnalytics/ModelDetails/');
      let modelDeployHistoryData = await getDeployHistory(
        ApiList.getDeployHistory,
        'ModelId',
        path1[1]
      );
      modelDeployRef.current.setFieldsValue({
        SourceServer: '',
        TargetServer: ''
      });
      setDeployModelVisible(false);
      setModelDeployHistoryData(modelDeployHistoryData);
      setModelDeploymentInfo({});
    });
  };
  const getDeployHistory1 = () => {
    let path1 = props.location.pathname.split('/rubus/RbsAnalytics/ModelDetails/');
    const fetchDeployHistory = async () => {
      try {
        const modelDeployHistoryData = await ApiList.getDeployHistory(
          'ModelId', 
          path1[1]
        );
        setModelDeployHistoryData(modelDeployHistoryData);
      } catch (error) {
        console.error('Error fetching deploy history:', error);
      }
    };
    fetchDeployHistory();
  };
  const getRealTimeRefreshHistory = async () => {
    let path1 = props.location.pathname.split('/rubus/RbsAnalytics/ModelDetails/');
    let modelPredRealtimeHistoryData =  await getDeployHistory(
      ApiList.getRealTimePredList,
      'ModelId',
      path1[1]
    );
    let data =
      modelPredRealtimeHistoryData &&
      Array.isArray(modelPredRealtimeHistoryData) &&
      modelPredRealtimeHistoryData.filter(
        (item) =>
          item.Status === 'Scheduled' || item.Status === 'Initiated' || item.Status === 'Running'
      ).length === 0
        ? false
        : true;
        setModelPredRealtimeHistoryData(modelPredRealtimeHistoryData);
        setRealTimeVal(data);
  };
  const getMetricResults = async (record) => {
    let metricResultData = await getDeployHistory(
      ApiList.getMetricResults,
      'PredReqId',
      record.PredReqId
    );
    setResultsDrawerVisible(true);
    setMetricValuesData(metricResultData && metricResultData.TableList ? metricResultData.TableList : null);
    setMetricImagesData(metricResultData && metricResultData.ImageList ? metricResultData.ImageList : null);
  };
  const getRealTimeMetricResults = async (values) => {
    let metricResultData = values;
    let metricValuesData1 = metricResultData && metricResultData.TableList ? metricResultData.TableList : null;
    let metricImagesData1 = metricResultData && metricResultData.ImageList ? metricResultData.ImageList : null;
    //This is used for getting only ROC Curve Object from all GraphList
    let rocCurveData = metricImagesData1 && Array.isArray(metricImagesData1) && metricImagesData1.filter((metric) => metric.MetricCode === 'ROC Curve');
    let rocCurveDataOptions = rocCurveData && rocCurveData[0] && rocCurveData[0].MetricValue;
    // This is used for getting only AUC Object from all GraphList
    let AUC = metricImagesData1 && Array.isArray(metricImagesData1) && metricImagesData1.filter((metric) => metric.MetricCode === 'AUC');
    let AUCData = AUC && AUC[0] && AUC[0].MetricValue;
    // This is used for getting Confusion Matrix Object from all GraphList
    let confusionMatrixObj = {};
    metricValuesData1 && Array.isArray(metricValuesData1) && metricValuesData1.forEach((ele) => {
      confusionMatrixObj[ele.MetricCode] = ele.MetricValue;
    });
    let LastIndexValue = rocCurveDataOptions && rocCurveDataOptions[rocCurveDataOptions.length - 1];
    let GraphListVal = metricImagesData1 && Array.isArray(metricImagesData1) && metricImagesData1.map((metric) => {
      return metric.MetricCode;
    });
    let confMatrixVisible = GraphListVal && GraphListVal.includes('Confusion Matrix');
    let rocCurveVisible = GraphListVal && GraphListVal.includes('ROC Curve');
    // Options to show Confusion Matrix Graph
    let option = {
      tooltip: {
        position: 'top'
      },
      // animation: false,
      grid: {
        height: '50%',
        top: '10%'
      },
      xAxis: {
        type: 'category',
        nameLocation: 'middle',
        name: translation('Predicted Label'),
        data: [0, 1],
        splitArea: {
          show: true
        }
      },
      yAxis: {
        type: 'category',
        name: translation('True Label'),
        nameLocation: 'middle',
        data: [1, 0],
        splitArea: {
          show: true
        }
      },
      visualMap: {
        min: 0,
        max: 100,
        calculable: true,
        orient: 'horizontal',
        left: 'center',
        bottom: '15%',
        show: false,
        inRange: {
          color: ['green', 'yellow']
        }
      },
      series: [
        {
          name: translation('Confusion Matrix'),
          type: 'heatmap',
          label: {
            show: true,
            position: 'inside'
          },
          data: [
            [0, 0, confusionMatrixObj['True negatives'] ? confusionMatrixObj['True negatives'] : 0],
            [1, 0, confusionMatrixObj['False positives'] ? confusionMatrixObj['False positives'] : 0],
            [0, 1, confusionMatrixObj['False negatives'] ? confusionMatrixObj['False negatives'] : 0],
            [1, 1, confusionMatrixObj['True positives'] ? confusionMatrixObj['True positives'] : 0]
          ],
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowColor: 'rgba(0,0,0,0.5)',
              borderColor: 'rgb(230, 226, 23)'
            }
          }
        }
      ]
    };
    // Options to show ROC Curve Graph
    let rocCurveOption = {
      xAxis: {
        name: 'False Positive Rate',
        nameLocation: 'middle',
        nameGap: 30
      },
      yAxis: {
        name: 'True Positive Rate',
        nameLocation: 'middle',
        nameGap: 30
      },
      graphic: [
        {
          type: 'text',
          z: 10,
          left: 'right',
          top: 'bottom',
          style: {
            fill: '#333',
            width: 220,
            // overflow: 'break',
            text: `AUC =${AUCData}`,
            font: '14px Microsoft YaHei'
          }
        }
      ],
      series: [
        {
          data: rocCurveDataOptions || 'undefined',
          type: 'line'
        },
        {
          data: [rocCurveDataOptions && rocCurveDataOptions[0], LastIndexValue],
          type: 'line',
          lineStyle: {
            color: 'red',
            width: 2,
            type: 'dashed'
          }
        }
      ]
    };
    setRealTimeResultsDrawerVisible(true);
    setMetricValuesData(metricValuesData1);
    setMetricImagesData(metricImagesData1);
    //setROCCurveData(rocCurveData);
    setOption(option);
    setRocCurveOption(rocCurveOption);
    setConfMatrixVisible(confMatrixVisible);
    setROCCurveVisible(rocCurveVisible);
  };
  const realTimeDateRangePicker = (e, key) => {
    let realTimePredResInfo = realTimePredResRef.current && realTimePredResRef.current.getFieldsValue();
    realTimePredResInfo = {
      ...realTimePredResInfo,
      [key]: e
    };
    getRealTimePredictionResultsList(realTimePredResInfo, e, true);
    realTimePredResRef.current.setFieldsValue(realTimePredResInfo);
    setRealTimePredResInfo(realTimePredResInfo);
  };
  const getRealTimePredictionResultsList = async (record, date, onChange) => {
    let payload = {
      PredReqId: record && record.PredReqId ? record.PredReqId : '',
      predictionFromTime: date !== undefined ? moment(date[0]).utc().format('YYYY-MM-DD HH:mm:ss') : null,
      predictionToTime: date !== undefined ? moment(date[1]).utc().format('YYYY-MM-DD HH:mm:ss') : null
    };
    let realPredictionResultsData = await DeployModel(ApiList.getRealTimePredictionResults, payload);
    // if (onChange === undefined) {
    //   _.cloneDeepWith(record, (value) => {
    //     return value !== null && value !== undefined
    //       ? {
    //         ...value,
    //         ...(value["FromTime"]
    //           ? (value["FromTime"] = moment(value.FromTime)
    //             .utc()
    //             .format("YYYY-MM-DD HH:mm:ss"))
    //           : null),
    //         ...(value["ToTime"]
    //           ? (value["ToTime"] = moment(value.ToTime)
    //             .utc()
    //             .format("YYYY-MM-DD HH:mm:ss"))
    //           : null),
    //       }
    //       : _.noop();
    //   });
    // }
    let data = {
      ...record,
      Date: [
        realPredictionResultsData && realPredictionResultsData[0] && realPredictionResultsData[0]['CurrentTime']
          ? dayjs.utc(realPredictionResultsData[0]['CurrentTime'], 'YYYY-MM-DD HH:mm:ss').local()
          : '',
        realPredictionResultsData && realPredictionResultsData[realPredictionResultsData.length - 1] && realPredictionResultsData[realPredictionResultsData.length - 1]['CurrentTime']
          ? dayjs.utc(realPredictionResultsData[realPredictionResultsData.length - 1]['CurrentTime'], 'YYYY-MM-DD HH:mm:ss').local()
          : ''
      ],
      FromTime: onChange === undefined
        ? dayjs(record.FromTime).utc().local().format('YYYY-MM-DD HH:mm:ss')
        : record.FromTime,
      ToTime: onChange === undefined
        ? dayjs(record.ToTime).utc().local().format('YYYY-MM-DD HH:mm:ss')
        : record.ToTime
    };
    setRealPredictionResultsData(realPredictionResultsData);
    setPredictionFromTime(data.FromTime);
    setPredictionToTime(data.ToTime);
    setRealTimePredResInfo(data);
    setFunctionalSummaryDailyFrom(
      data.FromTime > moment(data.ToTime).subtract(6, 'day').format('YYYY-MM-DD ')
        ? moment(data.FromTime).format('YYYY-MM-DD 00:00:00')
        : moment(data.ToTime).subtract(6, 'day').format('YYYY-MM-DD 00:00:00')
    );
    setFunctionalSummaryDailyTo(moment(data.ToTime).format('YYYY-MM-DD 23:59:59'));
    // setFunctionalSummaryWeeklyFrom(
    //   data.FromTime > moment(data.ToTime).subtract(27, 'day').format('YYYY-MM-DD')
    //     ? moment(data.FromTime).format('YYYY-MM-DD 00:00:00')
    //     : moment(data.ToTime).subtract(27, 'day').format('YYYY-MM-DD 00:00:00')
    // );
    setFunctionalSummaryWeeklyTo(moment(data.ToTime).format('YYYY-MM-DD 23:59:59'));
    setFunctionalSummaryWeekCount(4);
    // moment(data.ToTime).format('YYYY-MM-DD HH:mm:ss'),
    // data.FromTime > moment(data.ToTime).subtract(6, 'day').format('YYYY-MM-DD')
      //   ? moment(data.FromTime).format('YYYY-MM-DD HH:mm:ss')
      //   : moment(data.ToTime).subtract(27, 'day').format('YYYY-MM-DD HH:mm:ss'),
    //setFunctionalSummaryFrom(moment().subtract(60, 'minute').format('YYYY-MM-DD HH:mm'));
    setFunctionalSummaryTo(moment().add(15, 'minute').format('YYYY-MM-DD HH:mm'));
    realTimePredResRef.current && realTimePredResRef.current.setFieldsValue(data);
  };
  const dateRangePicker = (e, key) => {
    let predResInfo = predResRef.current && predResRef.current.getFieldsValue();
    predResInfo = {
      ...predResInfo,
      [key]: e
    };
    getPredictionResultsList(predResInfo, e, true);
    predResRef.current.setFieldsValue(predResInfo);
    setPredResInfo(predResInfo);
  };
  const getPredictionResultsList = async (record, date, onChange) => {
    let payload = {
      PredReqId: record && record.PredReqId ? record.PredReqId : '',
      predictionFromTime: date !== undefined ? dayjs(date[0]).utc().format('YYYY-MM-DD HH:mm:ss') : null,
      predictionToTime: date !== undefined ? dayjs(date[1]).utc().format('YYYY-MM-DD HH:mm:ss') : null
    };
    let predictionResultsData = await DeployModel(ApiList.getPredictionResults, payload);
    // if (onChange === undefined) {
    //   _.cloneDeepWith(record, (value) => {
    //     return value !== null && value !== undefined
    //       ? {
    //         ...value,
    //         ...(value["FromTime"]
    //           ? (value["FromTime"] = moment(value.FromTime)
    //             .utc()
    //             .format("YYYY-MM-DD HH:mm:ss"))
    //           : null),
    //         ...(value["ToTime"]
    //           ? (value["ToTime"] = moment(value.ToTime)
    //             .utc()
    //             .format("YYYY-MM-DD HH:mm:ss"))
    //           : null),
    //       }
    //       : _.noop();
    //   });
    // }
    let data = {
      ...record,
      Date: [
        predictionResultsData && predictionResultsData[0] && predictionResultsData[0]['CurrentTime']
          ? dayjs.utc(predictionResultsData[0]['CurrentTime'], 'YYYY-MM-DD HH:mm:ss').local()
          : '',
        predictionResultsData && predictionResultsData[predictionResultsData.length - 1] && predictionResultsData[predictionResultsData.length - 1]['CurrentTime']
          ? dayjs.utc(predictionResultsData[predictionResultsData.length - 1]['CurrentTime'], 'YYYY-MM-DD HH:mm:ss').local()
          : ''
      ],
      FromTime: onChange === undefined
        ? dayjs(record.FromTime).utc().local().format('YYYY-MM-DD HH:mm:ss')
        : record.FromTime,
      ToTime: onChange === undefined
        ? dayjs(record.ToTime).utc().local().format('YYYY-MM-DD HH:mm:ss')
        : record.ToTime
    };
    setPredictionResultsData(predictionResultsData);
    setPredictionFromTime(data.FromTime);
    setPredictionToTime(data.ToTime);
    setPredResInfo(data);
    setFunctionalSummaryDailyFrom(
      data.FromTime > moment(data.ToTime).subtract(6, 'day').format('YYYY-MM-DD ')
        ? moment(data.FromTime).format('YYYY-MM-DD 00:00:00')
        : moment(data.ToTime).subtract(6, 'day').format('YYYY-MM-DD 00:00:00')
    );
    setFunctionalSummaryDailyTo(moment(data.ToTime).format('YYYY-MM-DD 23:59:59'));
    // setFunctionalSummaryWeeklyFrom(
    //   data.FromTime > moment(data.ToTime).subtract(27, 'day').format('YYYY-MM-DD')
    //     ? moment(data.FromTime).format('YYYY-MM-DD 00:00:00')
    //     : moment(data.ToTime).subtract(27, 'day').format('YYYY-MM-DD 00:00:00')
    // );
    setFunctionalSummaryWeeklyTo(moment(data.ToTime).format('YYYY-MM-DD 23:59:59'));
    setFunctionalSummaryWeekCount(4);
    predResRef.current && predResRef.current.setFieldsValue(data);
  };
  const getPredictionHistory = async () => {
    let path1 = props.location.pathname.split('/rubus/RbsAnalytics/ModelDetails/');
    let modelPredHistoryData = await getDeployHistory(
      ApiList.getPredictionHistory,
      'ModelId',
      path1[1]
    );
    setModelPredHistoryData(modelPredHistoryData);
  };
  // const getRealTimeHistory = async () => {
  //   let path1 = props.location.pathname.split('/rubus/RbsAnalytics/ModelDetails/');
  //   let modelPredRealtimeHistoryData = await getDeployHistory(
  //     ApiList.getRealTimePredList,
  //     'ModelId',
  //     path1[1]
  //   );
  //   setModelDeployHistoryData(modelPredRealtimeHistoryData);
  // };
  const onPredictionRequestSubmit = () => {
    predictionRequestRef.current.validateFields().then(async (values) => {
      values = {
        FromTime: dayjs(predictionRequestRef.current.getFieldValue('FromTime'))
          .utc()
          .format('YYYY-MM-DD HH:mm:ss'),
        ToTime: dayjs(predictionRequestRef.current.getFieldValue('ToTime'))
          .utc()
          .format('YYYY-MM-DD HH:mm:ss'),
        Metrics: predictionRequestRef.current.getFieldValue('Metrics'),
        ModelId: formObject && formObject.ModelId ? formObject.ModelId : '',
        DepReqId: modelDeployHistoryData &&
        Array.isArray(modelDeployHistoryData) &&
        modelDeployHistoryData.filter((item) => item.Default === true) &&
        modelDeployHistoryData.filter((item) => item.Default === true)[0] &&
        modelDeployHistoryData.filter((item) => item.Default === true)[0]['ReqId']
        ? modelDeployHistoryData.filter((item) => item.Default === true)[0]['ReqId']
        : null,
        UserId: userProfile && userProfile.user && userProfile.user.Id ? userProfile.user.Id : ''
      };
      let response = await DeployModel(ApiList.predictionRequest, values);
      // if (response && response.status === 200) {
      message.success(response && response.message && translation(response.message)); // Ensure translation function is defined
      predictionRequestRef.current.setFieldsValue({
        FromTime: '',
        ToTime: ''
      });
      setPredictionModel(false);
      setRealTimePredictionReqInfo({});
      getPredictionHistory();
      // }
    });
  };
  const onRealTimePredictionRequestSubmit = () => {
    realTimePredictionRequestRef.current.validateFields().then(async (values) => {
      values = {
        // ...values,
        FromTime: dayjs(realTimePredictionRequestRef.current.getFieldValue('FromTime'))
          .utc()
          .format('YYYY-MM-DD HH:mm:ss'),
        ToTime: dayjs(realTimePredictionRequestRef.current.getFieldValue('ToTime'))
          .utc()
          .format('YYYY-MM-DD HH:mm:ss'),
        Metrics: realTimePredictionRequestRef.current.getFieldValue('Metrics'),
        ModelId: formObject && formObject.ModelId ? formObject.ModelId : '',
        PredReqId: realTimePredictionReqInfo && realTimePredictionReqInfo.PredReqId ? realTimePredictionReqInfo.PredReqId : null,
        UserId: userProfile && userProfile.user && userProfile.user.Id ? userProfile.user.Id : ''
      };
      let response = await DeployModel(ApiList.getRealTimeMetricResults, values);
      if (response && response.message) {
        message.success(response && response.message && translation(response.message)); // Ensure translation function is defined
      }
      let context = {};
        //reduce is used for converting the response into two arrays to get table data and Graph data in individaual arrays
      if (response && Array.isArray(response)) {
        context = response.reduce(
          (Metric, el) => {
            if (el.MetricCode !== 'Confusion Matrix' && el.MetricCode !== 'ROC Curve' && el.MetricCode !== 'AUC') {
              Metric.TableList.push(el);
            } else {
              Metric.ImageList.push(el);
            }
            return Metric;
          },
          { TableList: [], ImageList: [] }
        );
      }
      setRealTimeMetricResultVisible(true);
     // setMetricCalResponse(context.ImageList);
     // setMetricResultVisible(true);
      getRealTimeMetricResults(context);
    });
  };
  const onRealTimeModelSubmit = () => {
    realTimeModelRef.current.validateFields().then(async (values) => {
      _.cloneDeepWith(values, (value) => {
        return value !== null && value !== undefined
          ? {
            // ...value,
            ...(value['FromTime']
              ? (value['FromTime'] = dayjs(value.FromTime).utc().format('YYYY-MM-DD HH:mm:ss'))
              : null),
            ...(value['ToTime']
              ? (value['ToTime'] = dayjs(value.ToTime).utc().format('YYYY-MM-DD HH:mm:ss'))
              : null)
          }
          : null;
      });
      values = {
        // ...values,
        FromTime: values.FromTime,
        ToTime: values.ToTime,
        Comments:
          realTimeModelRef.current &&
          realTimeModelRef.current.getFieldValue('Comments'),
        UserId: userProfile && userProfile.user && userProfile.user.Id ? userProfile.user.Id : '',
        ModelId: formObject && formObject.ModelId ? formObject.ModelId : '',
        Type: 'Realtime',
        DepReqId: modelDeployHistoryData && Array.isArray(modelDeployHistoryData) && modelDeployHistoryData.filter((item) => item.Default === true)[0] ? modelDeployHistoryData.filter((item) => item.Default === true)[0]['ReqId'] : null,
        DataSourceID: realTimeModelRef.current.getFieldValue('DataSourceID'),
        TargetServer: realTimeModelRef.current.getFieldValue('TargetServer'),
        Frequency: realTimeModelRef.current.getFieldValue('Frequency'),
        // isCondition: addCondition
      };
      let response = await DeployModel(ApiList.realTimeCreate, values);
      message.success(response && response.message && translation(response.message)); // Ensure translation function is defined
      let payload = {
        PredReqId: response && response.PredReqId,
        modelType,
        modelName,
        status,
        Operator: realTimeModelRef.current.getFieldValue('Operator'),
        mailRecipient,
        CommunicationTypes: selectedCommunication
      };
      if (payload && payload.Operator && payload.Operator === 'Between') {
        payload.Value = [value1, value2];
      } else if (['<', '>', '>=', '<='].includes(payload.Operator)) {
        payload.Value = [value];
      } else if (['==', '!='].includes(payload.Operator)) {
        payload.Value = realTimeModelRef.current.getFieldValue('Value');
      }
      if (response && response.PredReqId) {
        let conditionResponse = await DeployModel(ApiList.realTimeConditionsCreate, payload);
        if (conditionResponse && conditionResponse.message) {
          message.success(conditionResponse && conditionResponse.message && translation(conditionResponse.message)); 
        }
      }
      getRealTimeRefreshHistory();
      realTimeModelRef.current.setFieldsValue({
        FromTime: dayjs(),
        ToTime: null,
        DataSourceID: null,
        TargetServer: null,
        Frequency: null,
        Comments: null,
        ModelName: modelName,
        ModelType: modelType,
        Operator: null,
        Value: null,
        CommunicationTypes: [],
        MailRecipient: []
      });
      setRealTimeModel(false);
      setRealTimeInfo({});
      setSelectedCommunication([]);
      setMailRecipient([]);
      //setAddCondition(false);
      setStatus('Inactive');
    }).catch(() => { });
  };
  const onRealTimeModelUpdate = async () => {
    let payload = {
      modelType,
      modelName,
      Operator: selectedCondition,
      MailRecipient: mailRecipient,
      CommunicationTypes: selectedCommunication,
      Status: status,
      PredReqId: actionRecordPredReqId,
      Id: recordId
    };
    if (payload.Operator === 'Between') {
      payload.Value = [value1, value2];
    } else if (['<', '>', '>=', '<='].includes(payload.Operator)) {
      payload.Value = [value];
    } else if (['==', '!='].includes(payload.Operator)) {
      payload.Value = realTimeModelRef.current.getFieldValue('Value');
    }
    let conditionResponse = await DeployModel(ApiList.realTimeConditionsCreate, payload);
    if (conditionResponse && conditionResponse.message) {
      message.success(translation(conditionResponse.message)); 
    }
    setRealTimeModel(false);
    setRealTimeInfo({});
    setSelectedCondition(null);
    setMailRecipient([]);
    setSelectedCommunication([]);
    setValue(null);
    setValue1(null);
    setValue2(null);
    setStatus('Inactive');
    getRealTimeRefreshHistory();
  };
  const onChange = async (value, dateString) => {
    setMomentRange([moment(dateString[0]), moment(dateString[1])]);
    setDisableGraph(false);
    let startDate = moment(dateString[0]);
    let timeEnd = moment(dateString[1]);
    let diff = timeEnd.diff(startDate);
    let diffDuration = moment.duration(diff);
    let differenceHours = diffDuration.days();
    let difMin = Math.round((timeEnd - startDate) / 1000 / 60);
    if (differenceHours === 0 && difMin > 0) {
      if (dateString && dateString[0] && dateString[1]) {
        let payload = {
          PredReqId: realTimePredResInfo.PredReqId,
          startDate: moment(dateString[0]).utc().format('YYYY-MM-DD HH:mm:ss'),
          endDate: moment(dateString[1]).utc().format('YYYY-MM-DD HH:mm:ss')
        };
        let response = await RealTimeGraphData(payload);
        if (response && Array.isArray(response) && response.length === 0) {
          message.info(translation('No Data')); 
        } else {
          setRealTimeFunctionalSummary(response);
          //setRange([dateString[0], dateString[1]]);
          setDifferenceHours(differenceHours);
          setDifMin(difMin);
        }
      }
    } else {
      message.warn('Please Select valid range!');
      setRealTimeFunctionalSummary([]);
      setDifferenceHours(differenceHours);
      setDifMin(difMin);
    }
  };
  const quickRun = async () => {
    let currentDay = new Date();
    let startDate = currentDay.setMinutes(currentDay.getMinutes() - 1);
    let payload = {
      FromTime: moment(startDate).utc().format('YYYY-MM-DD HH:mm:ss'),
      ToTime: moment().utc().format('YYYY-MM-DD HH:mm:ss'),
      Type: 'QuickRun',
      UserId: userProfile && userProfile.user && userProfile.user.Id ? userProfile.user.Id : '',
      DepReqId:
      modelDeployHistoryData &&
        Array.isArray(modelDeployHistoryData) &&
        modelDeployHistoryData.filter((item) => item.Default === true) &&
        modelDeployHistoryData.filter((item) => item.Default === true)[0] &&
        modelDeployHistoryData.filter((item) => item.Default === true)[0]['ReqId']
        ? modelDeployHistoryData.filter((item) => item.Default === true)[0]['ReqId']
        : null,
      ModelId: formObject && formObject.ModelId ? formObject.ModelId : '',
      DataSourceID: dataSourceId
    };
    let response = await DeployModel(ApiList.realTimeCreate, payload);
    message.success(response && response.message && translation(response.message)); // Ensure translation function is defined
    quickRunModalRef.current && quickRunModalRef.current.setFieldsValue({
      DataSourceID: null
    });
    setQuickRunModal(false);
    setDataSourceId(null);
    getRealTimeRefreshHistory(); 
  };
  const onFinishFailed = () => {
    message.error(translation('Please Enter Mandatory Fields')); 
  };
  // const defaultDeployConfirm = async (record) => {
  //   let values = {
  //     ModelId: formObject && formObject.ModelId ? formObject.ModelId : '',
  //     UserId: userProfile && userProfile.user && userProfile.user.Id ? userProfile.user.Id : '',
  //     DepReqId: record.ReqId
  //   };
  //   let response = await DeployModel(ApiList.updateDefaultStatus, values);
  //   // if (response && response.status === 200) {
  //   getDeployHistory(); 
  //   message.success(response && response.message && translation(response.message)); // Ensure translation function is defined
  //   // }
  // };
  // const getDisabledTrendHours = (e, current, type) => {
  //   let hours = [];
  //   let minutes = [];
  //   let seconds = [];
  //   let StartDateTime = moment(current).format('YYYY-MM-DD HH:mm:ss');
  //   let EndDateTime = moment(current).format('YYYY-MM-DD HH:mm:ss');
  //   let StartDate = moment(current).format('YYYY-MM-DD');
  //   let EndDate = moment(current).format('YYYY-MM-DD');
  //   let currentDate = moment(e).format('YYYY-MM-DD');
  //   let currentDateTime = moment(e).format('YYYY-MM-DD HH:mm:ss');
  //   if (
  //     moment(currentDate).isSame(
  //       moment(StartDate) ||
  //       moment(currentDateTime).hours() === moment(StartDateTime).hours() ||
  //       moment(currentDateTime).minutes() === moment(StartDateTime).minutes()
  //     ) &&
  //     type === 'start'
  //   ) {
  //     for (var i = 0; i <= 24; i++) {
  //       if (i > moment(StartDateTime).hours()) {
  //         hours.push(i);
  //       }
  //     }
  //     if (moment(currentDate).isSame(StartDate)) {
  //       for (var j = 0; j <= 60; j++) {
  //         if (j > moment(StartDateTime).minutes()) {
  //           minutes.push(j);
  //         }
  //       }
  //     }
  //     if (moment(currentDate).isSame(StartDate)) {
  //       for (let l = 0; l <= 60; l++) {
  //         if (l < moment(StartDateTime).seconds()) {
  //           seconds.push(l);
  //         }
  //       }
  //     }
  //     return {
  //       disabledHours: () => hours,
  //       disabledMinutes: () => minutes,
  //       disabledSeconds: () => seconds
  //     };
  //   } else if (
  //     moment(currentDate).isSame(
  //       moment(EndDate) ||
  //       moment(currentDateTime).hours() === moment(EndDateTime).hours() ||
  //       moment(currentDateTime).minutes() === moment(EndDateTime).minutes()
  //     ) &&
  //     type === 'end'
  //   ) {
  //     for (var k = 0; k <= 24; k++) {
  //       if (k < moment(EndDateTime).hours()) {
  //         hours.push(k);
  //       }
  //     }
  //     if (moment(currentDate).isSame(EndDate)) {
  //       for (var J = 0; J <= 60; J++) {
  //         if (J < moment(EndDateTime).minutes()) {
  //           minutes.push(J);
  //         }
  //       }
  //     }
  //     if (moment(currentDate).isSame(EndDate)) {
  //       for (var K = 0; K <= 60; K++) {
  //         if (K < moment(EndDateTime).seconds()) {
  //           seconds.push(K);
  //         }
  //       }
  //     }
  //     // for (var k = 0; k < moment(EndDateTime).hours(); k++) {
  //     //   if (k < 25) {
  //     //     hours.push(k);
  //     //   }
  //     // }
  //     // if (moment(currentDate).isSame(moment(EndDate))) {
  //     //   for (var J = 0; J < moment(EndDateTime).minutes() + 1; J++) {
  //     //     if (J < 61) {
  //     //       minutes.push(J);
  //     //     }
  //     //   }
  //     // }
  //     return {
  //       disabledHours: () => hours,
  //       disabledMinutes: () => minutes,
  //       disabledSeconds: () => seconds
  //     };
  //   }
  // };
  // const getDisabledHours = (e, from, to) => {
  //   let hours = [];
  //   let minutes = [];
  //   let seconds = [];
  //   let StartDateTime = moment(from).format('YYYY-MM-DD HH:mm:ss');
  //   let EndDateTime = moment(to).format('YYYY-MM-DD HH:mm:ss');
  //   let StartDate = moment(from).format('YYYY-MM-DD');
  //   let EndDate = moment(to).format('YYYY-MM-DD');
  //   let currentDate = moment(e).format('YYYY-MM-DD');
  //   if (
  //     moment(currentDate).isSame(StartDate)
  //   ) {
  //     for (var i = 0; i <= 24; i++) {
  //       if (i < moment(StartDateTime).hours()) {
  //         hours.push(i);
  //       }
  //     }
  //     if (moment(currentDate).isSame(StartDate)) {
  //       for (var j = 0; j <= 60; j++) {
  //         if (j < moment(StartDateTime).minutes()) {
  //           minutes.push(j);
  //         }
  //       }
  //     }
  //     if (moment(currentDate).isSame(StartDate)) {
  //       for (var l = 0; l <= 60; l++) {
  //         if (l < moment(StartDateTime).seconds()) {
  //           seconds.push(l);
  //         }
  //       }
  //     }
  //     return {
  //       disabledHours: () => hours,
  //       disabledMinutes: () => minutes,
  //       disabledSeconds: () => seconds
  //     };
  //   } else if (
  //     moment(currentDate).isSame(EndDate)
  //   ) {
  //     for (var k = 0; k <= 24; k++) {
  //       if (k > moment(EndDateTime).hours()) {
  //         hours.push(k);
  //       }
  //     }
  //     if (moment(currentDate).isSame(EndDate)) {
  //       for (var J = 0; J <= 60; J++) {
  //         if (J > moment(EndDateTime).minutes()) {
  //           minutes.push(J);
  //         }
  //       }
  //     }
  //     if (moment(currentDate).isSame(EndDate)) {
  //       for (var K = 0; K <= 60; K++) {
  //         if (K > moment(EndDateTime).seconds()) {
  //           seconds.push(K);
  //         }
  //       }
  //     }
  //     // for (var k = 0; k < moment(EndDateTime).hours(); k++) {
  //     //   if (k < 25) {
  //     //     hours.push(k);
  //     //   }
  //     // }
  //     // if (moment(currentDate).isSame(moment(EndDate))) {
  //     //   for (var J = 0; J < moment(EndDateTime).minutes() + 1; J++) {
  //     //     if (J < 61) {
  //     //       minutes.push(J);
  //     //     }
  //     //   }
  //     // }
  //     return {
  //       disabledHours: () => hours,
  //       disabledMinutes: () => minutes,
  //       disabledSeconds: () => seconds
  //     };
  //   }
  // };
  // const cancel = () => {
  //   message.error(translation('Click on No')); 
  // };
  const onCheck = (key, value) => {
    let predictionRequestInfo = predictionRequestRef.current && predictionRequestRef.current.getFieldsValue();
    predictionRequestInfo = {
      ...predictionRequestInfo,
      [key]: value
    };
    predictionRequestRef.current.setFieldsValue(predictionRequestInfo);
    setPredictionRequestInfo(predictionRequestInfo);
  };
  const onMetricCheck = (key, value) => {
    let realTimePredictionRequestInfo = realTimePredictionRequestRef.current && realTimePredictionRequestRef.current.getFieldsValue();
    realTimePredictionRequestInfo = {
      ...realTimePredictionRequestInfo,
      [key]: value
    };
    realTimePredictionRequestRef.current.setFieldsValue(realTimePredictionRequestInfo);
    setRealTimePredictionRequestInfo(realTimePredictionRequestInfo);
  };
  // const reset = () => { };
  // const getDisabledHoursTask = (e, key) => {
  //   let hours = [];
  //   let minutes = [];
  //   let StartDateTime = '';
  //   let EndDateTime = '';
  //   let StartDate = '';
  //   let EndDate = '';
  //   if (key === 'StartTime') {
  //     StartDateTime = moment(e).format('YYYY-MM-DD HH:mm');
  //     EndDateTime = moment.utc(taskRef.current.getFieldValue('EndTime'), 'YYYY-MM-DD HH:mm').local();
  //     StartDate = moment(e).format('YYYY-MM-DD');
  //     EndDate = moment.utc(taskRef.current.getFieldValue('EndTime')).local().format('YYYY-MM-DD');
  //   } else if (key === 'EndTime') {
  //     StartDateTime = moment.utc(taskRef.current.getFieldValue('StartTime'), 'YYYY-MM-DD HH:mm').local();
  //     EndDateTime = moment(e).format('YYYY-MM-DD HH:mm');
  //     StartDate = moment.utc(taskRef.current.getFieldValue('StartTime')).local().format('YYYY-MM-DD');
  //     EndDate = moment(e).format('YYYY-MM-DD');
  //   }
  //   if (
  //     key === 'StartTime' &&
  //     moment(StartDate).isSame(moment(EndDate)) &&
  //     (moment(StartDateTime).hours() === moment(EndDateTime).hours())
  //   ) {
  //     for (let i = 0; i <= 24; i++) {
  //       if (i > moment(EndDateTime).hours()) {
  //         hours.push(i);
  //       }
  //     }
  //     if (moment(StartDate).isSame(moment(EndDate))) {
  //       for (var j = 0; j <= 60; j++) {
  //         if (j > moment(EndDateTime).minutes() - 1) {
  //           minutes.push(j);
  //         }
  //       }
  //     }
  //     return {
  //       disabledHours: () => hours,
  //       disabledMinutes: () => minutes
  //     };
  //   } else if (
  //     key === 'EndTime' &&
  //     moment(StartDate).isSame(moment(EndDate)) &&
  //     (moment(StartDateTime).hours() === moment(EndDateTime).hours())
  //   ) {
  //     for (let k = 0; k <= 24; k++) {
  //       if (k < moment(StartDateTime).hours()) {
  //         hours.push(k);
  //       }
  //     }
  //     if (moment(StartDate).isSame(moment(EndDate))) {
  //       for (let J = 0; J <= 60; J++) {
  //         if (J < moment(StartDateTime).minutes()) {
  //           minutes.push(J);
  //         }
  //       }
  //     }
  //     return {
  //       disabledHours: () => hours,
  //       disabledMinutes: () => minutes
  //     };
  //   }
  // };
  const deviceOnChange = async (selectedDeviceList, formObject) => {
    let payload = {
      DeviceCode: selectedDeviceList,
      ModelId: formObject && formObject.ModelId ? formObject.ModelId : ''
    };
    let response = await RegisterModel(ApiList.getParameterByDevice, payload);
    setParameterList(response && response.data && response.data.Operational ? response.data.Operational : []);
  };
  const onParameterChange = (e) => {
    let selectedDeviceParameter = [];
    parameterList &&
      Array.isArray(parameterList) &&
      parameterList.filter((el) => {
        e.find((element) => {
          if (el.ParameterCode === element) {
            selectedDeviceParameter.push({
              DeviceCode: el.Device,
              ParameterCode: el.ParameterCode
            });
          }
        });
      });
    setSelectedDeviceParameter(selectedDeviceParameter);
  };
  const onTrendSubmit = async () => {
    let payload = {
      Type: 'historic',
      ViewType: 'Multiple',
      GraphType: 'Line',
      Operator: 'LAST',
      ParameterList: selectedDeviceParameter,
      FromDate: trendRef.current && trendRef.current.getFieldValue('FromDate')
        ? dayjs(trendRef.current.getFieldValue('FromDate')).utc().format('YYYY-MM-DD HH:mm:ss')
        : '',
      ToDate: trendRef.current && trendRef.current.getFieldValue('ToDate')
        ? dayjs(trendRef.current.getFieldValue('ToDate')).utc().format('YYYY-MM-DD HH:mm:ss')
        : '',
      Interval: trendRef.current && trendRef.current.getFieldValue('Interval')
        ? trendRef.current.getFieldValue('Interval')
        : ''
    };
    let response = await DeployModel(ApiList.generateTrend, payload);
    // if (response && response.status === 200) {
    setTrendData(response);
   // }
  };
  const onTrendSubmitRealTime = async () => {
    let payload = {
      Type: 'historic',
      ViewType: 'Multiple',
      GraphType: 'Line',
      Operator: 'LAST',
      ParameterList: selectedDeviceParameter,
      FromDate: realTimeTrendRef.current && realTimeTrendRef.current.getFieldValue('FromDate')
        ? dayjs(realTimeTrendRef.current.getFieldValue('FromDate')).utc().format('YYYY-MM-DD HH:mm:ss')
        : '',
      ToDate: realTimeTrendRef.current && realTimeTrendRef.current.getFieldValue('ToDate')
        ? dayjs(realTimeTrendRef.current.getFieldValue('ToDate')).utc().format('YYYY-MM-DD HH:mm:ss')
        : '',
      Interval: realTimeTrendRef.current && realTimeTrendRef.current.getFieldValue('Interval')
        ? realTimeTrendRef.current.getFieldValue('Interval')
        : ''
    };
    let response = await DeployModel(ApiList.generateTrend, payload);
    // if (response && response.status === 200) {
      setTrendData(response);
      // }
  };
  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };
  const handleReset = (clearFilters, confirm) => {
    clearFilters();
    confirm();
    setSearchText('');
  };
  const handleDateInputChange = (dateString) => {
    let data = predictionRequestRef.current && predictionRequestRef.current.getFieldValue();
    let trainedFrom = data.TrainPeriodFrom;
    let trainedTo = data.TrainPeriodTo;
    let date = moment(dateString).format('YYYY-MM-DD HH:mm:ss');
    if (date >= trainedFrom && date <= trainedTo) {
      message.error(
        'This date range overlaps with model training period. The prediction results may not reflect the accuracy of the unseen data. Do you want to continue?'
      );
    } else {
      return null;
    }
  };
  const handleMetricDateInputChange = (dateString) => {
    let data = realTimePredictionRequestRef.current && realTimePredictionRequestRef.current.getFieldValue();
    let fromTime = data.FromTime;
    let toTime = data.ToTime;
    let date = dayjs(dateString).format('YYYY-MM-DD HH:mm:ss');
    if (date >= fromTime && date <= toTime) {
      message.error(
        'This date range overlaps with model training period. The prediction results may not reflect the accuracy of the unseen data. Do you want to continue?'
      );
    } else {
      return null;
    }
  };
  const handleRealTimeDateInputChange = (dateString) => {
    let data = realTimeModelRef.current && realTimeModelRef.current.getFieldValue();
    let fromTime = data && data.FromTime;
    let toTime = data && data.ToTime;
    let date = moment(dateString).format('YYYY-MM-DD HH:mm:ss');
    if (date >= fromTime && date <= toTime) {
      message.error(
        'This date range overlaps with model training period. The prediction results may not reflect the accuracy of the unseen data. Do you want to continue?'
      );
    } else {
      return null;
    }
  };
  const handleTableChange = (pagination) => {
    const pager = { ...pagination };
    pager.current = pagination.current;
    setPagination(pager);
  };
  const handleRealtimeTableChange = (pagination) => {
    const pager = { ...pagination };
    pager.current = pagination.current;
    setPagination(pager);
  };
  const onValueChange = (e) => {
    setValue(e.target.value);
  };
  const onValueChange1 = (e) => {
    setValue1(e.target.value);
  };
  const onValueChange2 = (e) => {
    setValue2(e.target.value);
  };
  const onConditionChange = (value) => {
    if (value) {
      setSelectedCondition(value);
    }
  };
  const handleRecipientList = (value) => {
    if (value && Array.isArray(value) && value.length > 5) {
      message.error('Max 5 Users are allowed');
    } else {
      setMailRecipient(value);
    }
  };
  // const handleContinous = (e) => {
  //   setOnContinous(e.target.checked);
  // };
//   const handleFrequency = (value) => {
//     let time = value._d.toTimeString().split(' ')[0];
//     let splitTime = time.split(':');
//     let frequencyTime = parseInt(splitTime[0] * 3600) + parseInt(splitTime[1] * 60) + parseInt(splitTime[2]);
//     let frequency = [frequencyTime, time];
//  // if (index === undefined) {
//     // typeList = { ...state[type] };
//     //frequency = [frequencyTime, time];
//     // } else {
//     //   typeList = [...state[type]];
//     //   typeList[index]['frequency'] = [frequencyTime, time];
//     // }
//     setFrequency(frequency);
//   };
  const checkOnChange = (values) => {
    setSelectedCommunication(values);
  };
  // const handleDelay = (value) => {
  //   let time = value._d.toTimeString().split(' ')[0];
  //   let splitTime = time.split(':');
  //   let delayTime = parseInt(splitTime[0] * 3600) + parseInt(splitTime[1] * 60) + parseInt(splitTime[2]);
  //   let delay = [delayTime, time];
  //   setDelay(delay);
  // };
  const onStatusCheck = (e) => {
    if (e.target.checked === true) {
      setStatus('Active');
    } else {
      setStatus('Inactive');
    }
  };
  const QuickRunStopJob = async (record) => {
    let payload = {
      PredReqId: record.PredReqId
    };
    let response = await DeployModel(ApiList.realTimeStop, payload);
    message.success(response && response.message && translation(response.message)); // Ensure translation function is defined
    getRealTimeRefreshHistory(); 
  };
  const getAnalyticsActionsLog = async (record) => {
    let payload = {
      PredReqId: record && record.PredReqId ? record.PredReqId : ''
    };
    // let payload = {
    //   "PredReqId": 27
    // };
    let actionsLogResponse = await DeployModel(ApiList.getAnalyticsActionsLog, payload);
    setActionsLogDataSource(actionsLogResponse);
  };
  const onStartClick = () => {
    realTimePredictionRequestRef.current && realTimePredictionRequestRef.current.setFieldsValue({
      FromTime: dayjs()
    });
   const  RealTimeInfo = {
      ...realTimeInfo,
      FromTime: dayjs()
    };
    setRealTimeInfo(RealTimeInfo);
    setRealTimeModel(true);
    setButtonKey('start');
  };
  const QuickRunResults = async (record) => {
    const  QuickRunResults = await getMetaData(
      ApiList.getQuickrunResults,
      'PredReqId',
      record.PredReqId
    );
    quickRunResultsRef.current && quickRunResultsRef.current.setFieldsValue({
      ActualValue: QuickRunResults && QuickRunResults[0] && QuickRunResults[0].ActualValue,
      PredictedValue: QuickRunResults && QuickRunResults[0] && QuickRunResults[0].PredictedValue
    });
    setQuickRunInfo(QuickRunResults && QuickRunResults[0] ? QuickRunResults[0] : {});
  };
  const onDataSourceChange = (value) => {
    setDataSourceId(value);
  };
  const getRealTimeFunctionalSummary = async (functionalSummaryFrom, functionalSummaryTo) => {
    let payload = {
      PredReqId: realTimePredResInfo.PredReqId,
      startDate: moment(functionalSummaryFrom).utc().format('YYYY-MM-DD HH:mm'),
      endDate: moment(functionalSummaryTo).utc().format('YYYY-MM-DD HH:mm')
    };
    let response = await RealTimeGraphData(payload);
    if (response && Array.isArray(response) && response.length === 0) {
      message.info(translation('No Data'));
    }
    let selectionDateRange = {
      startDate: functionalSummaryFrom,
      endDate: functionalSummaryTo
    };
    setRealTimeFunctionalSummary(response || []);
    setMomentRange([functionalSummaryFrom, functionalSummaryTo]);
   // setFunctionalSummaryFrom(functionalSummaryFrom);
    setFunctionalSummaryTo(functionalSummaryTo);
    setSelectionDateRange(selectionDateRange);
  };
  // const disabledDates = (current) => {
  //   return current > moment().endOf('day');
  // };
  const ModelDeployHistoryColumns = [
    {
      title: translation('Inference Server'),
      dataIndex: 'InferenceServer',
      key: 'InferenceServer',
      ...getColumnSearchProps('InferenceServer')
    },
    {
      // {
      //   title: translation('Start Time'),
      //   dataIndex: 'DepStartTime',
      //   key: 'DepStartTime',
      //   ...getColumnSearchProps('DepStartTime'),
      //   sorter: (a, b) =>
      //     a.DepStartTime && b.DepStartTime && a.DepStartTime.localeCompare(b.DepStartTime),
      //   render: (text) => {
      //     return {
      //       children:
      //         text !== undefined && text !== null ? (
      //           <div>{moment(text).utc().local().format('YYYY-MM-DD HH:mm:ss')}</div>
      //         ) : null
      //     };
      //   }
      // },
      // {
      //   title: translation('End Time'),
      //   dataIndex: 'DepEndTime',
      //   key: 'DepEndTime',
      //   ...getColumnSearchProps('DepEndTime'),
      //   sorter: (a, b) => a.DepEndTime && b.DepEndTime && a.DepEndTime.localeCompare(b.DepEndTime),
      //   render: (text) => {
      //     return {
      //       children:
      //         text !== undefined && text !== null ? (
      //           <div>{moment(text).utc().local().format('YYYY-MM-DD HH:mm:ss')}</div>
      //         ) : null
      //     };
      //   }
      // },
      title: translation('Deployed By'),
      dataIndex: 'CreatedName',
      key: 'CreatedName'
    },
    {
      title: translation('Deployed Date'),
      dataIndex: 'CreatedTime',
      key: 'CreatedTime',
      ...getColumnSearchProps('CreatedTime'),
      sorter: (a, b) =>
        a.CreatedTime && b.CreatedTime && a.CreatedTime.localeCompare(b.CreatedTime),
      render: (text) => {
        return {
          children:
            text !== undefined ? (
              <div>{moment(text).utc().local().format('YYYY-MM-DD HH:mm:ss')}</div>
            ) : null
        };
      }
    },
    {
      title: translation('Status'),
      dataIndex: 'Status',
      key: 'Status',
      filters: [
        { text: translation('Initiated'), value: 'Initiated' },
        { text: translation('In-Progress'), value: 'In-Progress' },
        { text: translation('Completed Error'), value: 'Completed Error' },
        { text: translation('Completed'), value: 'Completed' }
      ],
      onFilter: (value, record) => record.Status === value
    },
// {
      //   title: translation('Default'),
      //   dataIndex: 'Default',
      //   key: 'Default',
      //   filters: [
      //     {
      //       text: translation('True'),
      //       value: true
      //     },
      //     {
      //       text: translation('False'),
      //       value: false
      //     }
      //   ],
      //   filterResetToDefaultFilteredValue: false,
      //   onFilter: (value, record) => record.Default === value,
      //   // ...getColumnSearchProps("Default"),
      //   render: (text, record) =>
      //     record.Status === 'Completed' ? (
      //       <Popconfirm
      //         title={translation('Do you want to make this deployment as default?')}
      //         icon={<QuestionCircleOutlined />}
      //         onConfirm={() => defaultDeployConfirm(record)}
      //         onCancel={() => cancel()}
      //         okText={translation('Yes')}
      //         cancelText={translation('No')}
      //       >
      //         <Checkbox checked={text} />
      //       </Popconfirm>
      //     ) : (
      //       <Checkbox disabled checked={text} />
      //     )
      // }
    // {
    //   title: translation('Action'),
    //   render: (text, record) => (
    //     <>
    //       <a
    //         style={{ marginRight: '10px' }}
    //         onClick={() => {
    //           let modelDetails = predictionRequestRef.current.getFieldsValue();
    //           let deploymentData = modelDeployHistoryData.filter((item) => item.Default === true)[0];
    //           let date1 = new Date(record.FromTime);
    //           let date2 = new Date(record.ToTime);
    //           let data = {
    //             ...record,
    //             FromTime: dayjs(date1).utc().local(),
    //             ToTime: dayjs(date2).utc().local(),
    //             ...modelDetails,
    //             ...deploymentData
    //           };
    //           predictionRequestRef.current.setFieldsValue(data);
    //           setPredictionModel(true);
    //           setPredictionRequestInfo(data);
    //         }}
    //       >
    //         {translation('Details')}
    //       </a>
    //       <a
    //         onClick={() => {
    //           if (record.Status === 'Completed') {
    //             getMetricResults(record); // Ensure this function is defined
    //             getPredictionResultsList(record); // Ensure this function is defined
    //             setPredictionRequestInfo(record);
    //           }
    //         }}
    //         disabled={record.Status !== 'Completed'}
    //       >
    //         {translation('Results')}
    //       </a>
    //     </>
    //   )
    // }
  ];
  const ModelPredHistoryColumns = [
    {
      title: translation('Predicted Time From'),
      dataIndex: 'FromTime',
      key: 'FromTime',
      ...getColumnSearchProps('FromTime'),
      sorter: (a, b) => a.FromTime && b.FromTime && a.FromTime.localeCompare(b.FromTime),
      render: (text) => {
        return {
          children:
            text !== undefined && text !== null ? (
              <div>{moment(text).utc().local().format('YYYY-MM-DD HH:mm:ss')}</div>
            ) : null
        };
      }
    },
    {
      title: translation('Predicted Time To'),
      dataIndex: 'ToTime',
      key: 'ToTime',
      ...getColumnSearchProps('ToTime'),
      sorter: (a, b) => a.ToTime && b.ToTime && a.ToTime.localeCompare(b.ToTime),
      render: (text) => {
        return {
          children:
            text !== undefined && text !== null ? (
              <div>{moment(text).utc().local().format('YYYY-MM-DD HH:mm:ss')}</div>
            ) : null
        };
      }
    },
    {
      title: translation('Created By'),
      dataIndex: 'CreatedName',
      key: 'CreatedName',
      // filters: ,
      ...getColumnSearchProps('CreatedName'),
      sorter: (a, b) => a.CreatedName.length - b.CreatedName.length
        // onFilter: (value, record) => record.CreatedName === value,
    },
    {
      title: translation('Created Time'),
      dataIndex: 'CreatedTime',
      key: 'CreatedTime',
      ...getColumnSearchProps('CreatedTime'),
      sorter: (a, b) =>
        a.CreatedTime && b.CreatedTime && a.CreatedTime.localeCompare(b.CreatedTime),
      render: (text) => {
        return {
          children:
            text !== undefined && text !== null ? (
              <div>{moment(text).utc().local().format('YYYY-MM-DD HH:mm:ss')}</div>
            ) : null
        };
      }
    },
    {
      title: translation('Status'),
      dataIndex: 'Status',
      key: 'Status',
      filters: [
        { text: translation('Initiated'), value: 'Initiated' },
        { text: translation('In-Progress'), value: 'In-Progress' },
        { text: translation('Completed Error'), value: 'Completed Error' },
        { text: translation('Completed'), value: 'Completed' }
      ],
      onFilter: (value, record) => record.Status === value
    },
    {
      title: translation('Action'),
      render: (text, record) => (
        <>
          <a
            style={{ marginRight: '10px' }}
            onClick={() => {
              let modelDetails = modelRef.current.getFieldsValue();
              _.cloneDeepWith(record, (value) => {
                return value !== undefined && value !== null
                  ? {
                    ...value,
                    ...(value['FromTime']
                      ? (value['FromTime'] = dayjs.utc(value.FromTime, 'YYYY-MM-DD HH:mm:ss'))
                      : null),
                    ...(value['ToTime'] && value['ToTime'] !== null
                      ? (value['ToTime'] = dayjs.utc(value.ToTime, 'YYYY-MM-DD HH:mm:ss'))
                      : null)
                  }
                  : _.noop();
              });
              let deploymentData =
                modelDeployHistoryData &&
                Array.isArray(modelDeployHistoryData) &&
                modelDeployHistoryData.filter((item) => item.Default === true) &&
                modelDeployHistoryData.filter((item) => item.Default === true)[0];
              deploymentData = {
                CreatedTime: moment(deploymentData.CreatedTime)
                  .utc()
                  .local()
                  .format('YYYY-MM-DD HH:mm:ss'),
                Virtualenv: deploymentData.Virtualenv
              };             
               let date1 = new Date(record.FromTime);
              let date2 = new Date(record.ToTime);
              let data = {
                ...record,
                FromTime: dayjs(date1).utc().local(),
                ToTime: dayjs(date2).utc().local(),
              };
              modelDetails = {
                ...data,
                ...modelDetails,
                ...deploymentData
              };
              predictionRequestRef.current.setFieldsValue(modelDetails);
              setPredictionModel(true);
              setPredictionRequestInfo(modelDetails);
            }}
          >
            {translation('Details')}
          </a>
          <a
            onClick={() => {
              if (record.Status === 'Completed') {
                getMetricResults(record); 
                getPredictionResultsList(record); 
                setPredictionReqInfo(record);
              }
            }}
            disabled={record.Status === 'Completed' ? false : true}
          >
            {translation('Results')}
          </a>
        </>
      )
    }
  ];
  const ModelPredRealtimeColumns = [
    {
      title: translation('Start Time'),
      dataIndex: 'FromTime',
      key: 'FromTime',
      ...getColumnSearchProps('FromTime'),
      sorter: (a, b) => a.FromTime && b.FromTime && a.FromTime.localeCompare(b.FromTime),
      render: (text) => ({
        children: text !== undefined && text !== null ? (
          <div>{moment(text).utc().local().format('YYYY-MM-DD HH:mm:ss')}</div>
        ) : null
      })
    },
    {
      title: translation('End Time'),
      dataIndex: 'ToTime',
      key: 'ToTime',
      ...getColumnSearchProps('ToTime'),
      sorter: (a, b) => a.ToTime && b.ToTime && a.ToTime.localeCompare(b.ToTime),
      render: (text) => ({
        children: text !== undefined && text !== null ? (
          <div>{moment(text).utc().local().format('YYYY-MM-DD HH:mm:ss')}</div>
        ) : null
      })
    },
    {
      title: translation('Type'),
      dataIndex: 'Type',
      key: 'Type',
      ...getColumnSearchProps('Type'),
      sorter: (a, b) => (a.Type && a.Type.length) - (b.Type && b.Type.length)
        // onFilter: (value, record) => record.CreatedName === value,
    },
    {
      title: translation('Status'),
      dataIndex: 'Status',
      key: 'Status',
      filters: [
        { text: translation('Initiated'), value: 'Initiated' },
        { text: translation('Scheduled'), value: 'Scheduled' },
        { text: translation('Running'), value: 'Running' },
        { text: translation('Stopped'), value: 'Stopped' },
        { text: translation('Completed'), value: 'Completed' }
      ],
      onFilter: (value, record) => record.Status === value
    },
    {
      title: translation('Created By'),
      dataIndex: 'CreatedName',
      key: 'CreatedName',
      ...getColumnSearchProps('CreatedName'),
      sorter: (a, b) => a.CreatedName && b.CreatedName && a.CreatedName.localeCompare(b.CreatedName)
    },
    {
      title: translation('Created Time'),
      dataIndex: 'CreatedTime',
      key: 'CreatedTime',
      ...getColumnSearchProps('CreatedTime'),
      sorter: (a, b) => a.CreatedTime && b.CreatedTime && a.CreatedTime.localeCompare(b.CreatedTime),
      render: (text) => ({
        children: text !== undefined && text !== null ? (
          <div>{moment(text).utc().local().format('YYYY-MM-DD HH:mm:ss')}</div>
        ) : null
      })
    },
    {
      title: translation('Action'),
      render: (text, record) => (
        <>
          {record.Status === 'Running' && record.Type !== 'QuickRun' ? (
            <Button
              key="edit"
              style={{ marginRight: 8 }}
              onClick={() => realTimeEdit(record, 'edit')} 
            >
              {translation('Edit')}
            </Button>
          ) : null}
          {record.Status === 'Running' && record.Type !== 'QuickRun' ? (
            <Button
              style={{ marginRight: 8 }}
              onClick={() => realTimeStopJob(record, 'stop')} 
            >
              {translation('Stop')}
            </Button>
          ) : null}
          {record.Status === 'Running' && record.Type === 'QuickRun' ? (
            <Button
              style={{ marginRight: 8 }}
              onClick={() => QuickRunStopJob(record, 'stop')} // Ensure QuickRunStopJob is defined
            >
              {translation('Stop')}
            </Button>
          ) : null}
          {(record.Status === 'Running' || record.Status === 'Stopped' || record.Status === 'Completed') && record.Type !== 'QuickRun' ? (
            <a
              onClick={() => {
                setRealTimeResultsDrawerVisible(true); 
                let realTimePredictionRequestInfo = {
                  FromTime: dayjs(record.FromTime),
                  ToTime: dayjs(record.ToTime),
                  Metrics: record.Metrics
                };
                realTimePredictionRequestRef.current && realTimePredictionRequestRef.current.setFieldsValue(realTimePredictionRequestInfo);
                setRealTimePredResInfo(realTimePredictionRequestInfo); 
                if ((record.Status === 'Running' || record.Status === 'Stopped' || record.Status === 'Completed') && record.Type !== 'QuickRun') {
                  getRealTimePredictionResultsList(record); 
                  getAnalyticsActionsLog(record); 
                  setRealTimePredictionReqInfo(record); 
                }
              }}
              // disabled={record.Status === "Completed" ? false : true}
            >
              {translation('Results')}
            </a>
          ) : null}
          {(record.Status === 'Running' || record.Status === 'Stopped' || record.Status === 'Completed') && record.Type === 'QuickRun' ? (
            <a
              onClick={() => {
                QuickRunResults(record); 
                setRealTimeQuickRunResultDrawer(true); 
              }}
            >
              {translation('Results')}
            </a>
          ) : null}
        </>
      )
    }
  ];
  const realTimePredictionCLFResultColumns = [
    {
      title: translation('Current Time'),
      dataIndex: 'CurrentTime',
      hide: true,
      key: 'CurrentTime',
      ...getColumnSearchProps('CurrentTime'),
      sorter: (a, b) => a.CurrentTime && b.CurrentTime && a.CurrentTime.localeCompare(b.CurrentTime),
      render: (text) => ({
        children: text !== undefined ? (
          <div>{moment(text).utc().local().format('YYYY-MM-DD HH:mm:ss')}</div>
        ) : null
      })
    },
    {
      title: translation('Predicted From'),
      dataIndex: 'predTimeFrom',
      key: 'predTimeFrom',
      ...getColumnSearchProps('predTimeFrom'),
      sorter: (a, b) => a.predTimeFrom && b.predTimeFrom && a.predTimeFrom.localeCompare(b.predTimeFrom),
      render: (text) => ({
        children: text !== undefined ? (
          <div>{moment(text).utc().local().format('YYYY-MM-DD HH:mm:ss')}</div>
        ) : null
      })
    },
    {
      title: translation('Predicted To'),
      dataIndex: 'predTimeTo',
      key: 'predTimeTo',
      ...getColumnSearchProps('predTimeTo'),
      sorter: (a, b) => a.predTimeTo && b.predTimeTo && a.predTimeTo.localeCompare(b.predTimeTo),
      render: (text) => ({
        children: text !== undefined ? (
          <div>{moment(text).utc().local().format('YYYY-MM-DD HH:mm:ss')}</div>
        ) : null
      })
    },
    {
      title: translation('Predicted Status'),
      dataIndex: 'PredictedStatus',
      key: 'PredictedStatus',
      filters: [
        { text: translation('NORMAL'), value: 'NORMAL' },
        { text: translation('ABNORMAL'), value: 'ABNORMAL' }
      ],
      onFilter: (value, record) => record.PredictedStatus === value
    },
    {
      title: translation('Actual Status'),
      dataIndex: 'ActualStatus',
      key: 'ActualStatus',
      filters: [
        { text: translation('NORMAL'), value: 'NORMAL' },
        { text: translation('ABNORMAL'), value: 'ABNORMAL' }
      ],
      onFilter: (value, record) => record.ActualStatus === value
    },
    {
      title: translation('View Trends'),
      render: (record) => (
        <Tooltip title={translation('Trends')}>
          <Button
            data-testid={'lift-hold-button'}
            style={{ marginRight: '5px' }}
            onClick={() => {
              let trendObj = realTimeTrendRef.current && realTimeTrendRef.current.getFieldsValue();
              let CurrentTime = dayjs.utc(record.CurrentTime, 'YYYY-MM-DD HH:mm:ss');
              let fromDate = dayjs(CurrentTime).subtract(1, 'hours').format('YYYY-MM-DD HH:mm:ss');
              let toDate = dayjs(CurrentTime).add(1, 'hours').format('YYYY-MM-DD HH:mm:ss');
              let defaultParameter = [];
             parameterList &&
                Array.isArray(parameterList) &&
               parameterList.map((item, index) => {
                  if (index < 5) {
                    defaultParameter.push(item.ParameterCode);
                  }
                });
              trendObj = {
                ...trendObj,
                DeviceCode:deviceList &&deviceList[0] &&deviceList[0]['Device'] ? [deviceList[0]['Device']] : [],
                ParameterCode: defaultParameter,
                FromDate: dayjs.utc(fromDate, 'YYYY-MM-DD HH:mm:ss').local(),
                ToDate: dayjs.utc(toDate, 'YYYY-MM-DD HH:mm:ss').local(),
                CurrentTime: dayjs.utc(CurrentTime, 'YYYY-MM-DD HH:mm:ss').local(),
                PredictionTargetFrom: dayjs(CurrentTime).utc().local().add(formObject &&formObject.FuturePredRangeFrom, 'minutes').format('DD-MM-YYYY HH:mm:ss'),
                PredictionTargetTo: dayjs(CurrentTime).utc().local().add(formObject && formObject.FuturePredRangeTo, 'minutes').format('DD-MM-YYYY HH:mm:ss'),
                Interval: intervalData && intervalData[0] && intervalData[0]['value'] ? intervalData[0]['value'] : ''
              };
              onParameterChange(defaultParameter); 
              realTimeTrendRef.current && realTimeTrendRef.current.setFieldsValue(trendObj);
              setTrendObj(trendObj); 
              setPredictionActiveKey('Trends'); 
            }}
            
          >
            <span>
              <LineChartOutlined />
            </span>
          </Button>
        </Tooltip>
      )
    }
  ];
  const actionsHistoryColumns = [
    {
      title: translation('Status'),
      dataIndex: 'Status',
      hide: true,
      key: 'Status',
      filters: [
        { text: translation('Active'), value: 'Active' },
        { text: translation('Inactive'), value: 'Inactive' }
      ],
      onFilter: (value, record) => record.Status === value
    },
    {
      title: translation('Recipients'),
      dataIndex: 'Recipients',
      key: 'Recipients'
        // ...getColumnSearchProps('Recipients'),
    },
    {
      title: translation('Notification Time'),
      dataIndex: 'NotificationTime',
      key: 'NotificationTime',
      ...getColumnSearchProps('NotificationTime'),
      sorter: (a, b) =>
        a.NotificationTime && b.NotificationTime && a.NotificationTime.localeCompare(b.NotificationTime),
      render: (text) => ({
        children: text !== undefined ? (
          <div>{moment(text).utc().local().format('YYYY-MM-DD HH:mm:ss')}</div>
        ) : null
      })
    },
    {
      title: translation('Channel'),
      dataIndex: 'Type',
      key: 'Type'
    }
  ];
  const metricResultColumns = [
    {
      title: translation('Metrics'),
      dataIndex: 'MetricCode',
      key: 'MetricCode'
    },
    {
      title: translation('Value'),
      dataIndex: 'MetricValue',
      key: 'MetricValue'
    }
  ];
  const RealTimeMetricResultColumns = [
    {
      title: translation('Metrics'),
      dataIndex: 'MetricCode',
      key: 'MetricCode'
    },
    {
      title: translation('Value'),
      dataIndex: 'MetricValue',
      key: 'MetricValue'
    }
  ];
  const rowSelection = {
    selectedRowKeys,
    onChange: (selectedRowKeys, selectedRows) => {
      if (
        selectedRows &&
        selectedRows[0] &&
        selectedRows[0]['Status'] &&
        selectedRows[0]['Status'] === 'Completed'
      ) {
        setSelectedRowKeys(selectedRowKeys);
        setSelectedRows(selectedRows);
      } else {
        message.error(translation('Please Select Completed Prediction To Compare'));
        setSelectedRowKeys([]);
        setSelectedRows([]);
      }
    },
    getCheckboxProps: (record) => ({
        //   disabled: record.name === 'Disabled User',
        // Column configuration not to be checked
      name: record.PredReqId
    })
  };
  const rowSelectionRealTime = {
    selectedRowKeys,
    onChange: (selectedRowKeys, selectedRows) => {
      if (
        selectedRows &&
        selectedRows[0] &&
        selectedRows[0]['Status'] &&
        selectedRows[0]['Status'] === 'Completed'
      ) {
        setSelectedRowKeys(selectedRowKeys);
        setSelectedRows(selectedRows);
      } else {
        message.error(translation('Please Select Completed Prediction To Compare'));
        setSelectedRowKeys([]);
        setSelectedRows([]);
      }
    },
    getCheckboxProps: (record) => ({
      name: record.PredReqId
    })
  };
  const validateMessages = {
    required: translation('${label}') + translation('is required!')
  };
  const formItemLayout = { width: '400px', flex: '50%' };
  const QuickRunItemLayout = {
    labelCol: {
      span: 4,
    },
    wrapperCol: {
      span: 12,
    },
  };
  let pathname = props.location.pathname;
  const items01 = [
    {
      key: 'Details',
      label: translation('Details'),
      children: (
        <div>
          <div style={{ display: 'flex', flexWrap: 'wrap', marginTop: '24px' }}>
            <Form.Item
              label={translation('Train Period')}
              name="TrainPeriodFrom"
              rules={[{ required: true }]}
              style={formItemLayout}
            >
              <Space.Compact>
                <Form.Item name="TrainPeriodFrom" rules={[{ required: true }]}>
                  <Input style={{ textAlign: 'center', width: 190 }} disabled />
                </Form.Item>
                <Form.Item rules={[{ required: true }]}>
                  <Input
                    style={{
                      width: 50,
                      borderLeft: 0,
                      borderRight: 0,
                      pointerEvents: 'none'
                    }}
                    placeholder={translation('To')}
                    disabled
                  />
                </Form.Item>
                <Form.Item name="TrainPeriodTo" rules={[{ required: true }]}>
                  <Input
                    style={{
                      textAlign: 'center',
                      borderLeft: 0,
                      width: 190
                    }}
                    disabled
                  />
                </Form.Item>
              </Space.Compact>
            </Form.Item>
            <Form.Item
              label={translation('Evaluation Period')}
              name="EvalPeriodFrom"
              rules={[{ required: true }]}
              style={formItemLayout}
            >
              <Space.Compact>
                <Form.Item name="EvalPeriodFrom">
                  <Input style={{ textAlign: 'center', width: 190 }} disabled />
                </Form.Item>
                <Form.Item rules={[{ required: true }]}>
                  <Input
                    style={{
                      width: 50,
                      borderLeft: 0,
                      borderRight: 0,
                      pointerEvents: 'none'
                    }}
                    placeholder={translation('To')}
                    disabled
                  />
                </Form.Item>
                <Form.Item name="EvalPeriodTo">
                  <Input
                    style={{
                      textAlign: 'center',
                      borderLeft: 0,
                      width: 190
                    }}
                    disabled
                  />
                </Form.Item>
              </Space.Compact>
            </Form.Item>
            <Form.Item
              label={translation('Future Prediction')}
              name="FuturePredRangeFrom"
              rules={[{ required: true }]}
              style={formItemLayout}
            >
              <Space.Compact>
                <Form.Item name="FuturePredRangeFrom">
                  <Input style={{ textAlign: 'center', width: 85 }} disabled />
                </Form.Item>
                <Form.Item rules={[{ required: true }]}>
                  <Input
                    style={{
                      width: 50,
                      borderLeft: 0,
                      borderRight: 0,
                      pointerEvents: 'none'
                    }}
                    placeholder={translation('To')}
                    disabled
                  />
                </Form.Item>
                <Form.Item name="FuturePredRangeTo">
                  <Input
                    style={{
                      textAlign: 'center',
                      borderLeft: 0,
                      width: 85
                    }}
                    disabled
                  />
                </Form.Item>
                <Form.Item rules={[{ required: true }]}>
                  <Input
                    style={{
                      width: 100,
                      borderLeft: 0,
                      borderRight: 0,
                      pointerEvents: 'none'
                    }}
                    placeholder={translation('UOM')}
                    disabled
                  />
                </Form.Item>
                <Form.Item name="FuturePredRangeUom">
                  <Input
                    style={{
                      textAlign: 'center',
                      borderLeft: 0,
                      width: 110
                    }}
                    disabled
                  />
                </Form.Item>
              </Space.Compact>
            </Form.Item>
            <Form.Item
              label={translation('Look back period')}
              rules={[{ required: true }]}
              style={formItemLayout}
            >
              <Space.Compact>
                <Form.Item name="LookBackPeriod">
                  <Input style={{ textAlign: 'center', width: 200 }} disabled />
                </Form.Item>
                <Form.Item rules={[{ required: true }]}>
                  <Input
                    style={{
                      width: 100,
                      borderLeft: 0,
                      borderRight: 0,
                      pointerEvents: 'none'
                    }}
                    placeholder={translation('UOM')}
                    disabled
                  />
                </Form.Item>
                <Form.Item name="LookBackPeriodUom">
                  <Input
                    style={{
                      textAlign: 'center',
                      borderLeft: 0,
                      width: 130
                    }}
                    disabled
                  />
                </Form.Item>
              </Space.Compact>
            </Form.Item>
            <Form.Item
              label={translation('Related Tags')}
              name="RelatedTagsList"
              rules={[{ required: true }]}
              style={formItemLayout}
            >
              <Button type="dashed" onClick={() => setModelVisible(true)}>
                {'...'}
              </Button>
            </Form.Item>
          </div>
          <StyledModal
            open={modelVisible}
            theme={themeSettings}
            width={800}
            closable
            title={translation('Related Tags')}
            onCancel={() => setModelVisible(false)}
            footer={[
              <Button key="back" onClick={() => setModelVisible(false)}>
                {translation('Cancel')}
              </Button>
            ]}
          >
            <div style={{ height: '70%', marginTop: '10px' }}>
              <Tree showLine defaultExpandAll={true} switcherIcon={<DownOutlined />}>
                {renderTreeNodes(renderTree(modelRef.current && modelRef.current.getFieldValue('RelatedTagsList')))}
              </Tree>
            </div>
          </StyledModal>
        </div>
      ),
    },
    {
      key: 'Deployment History',
      label: translation('Deployment History'),
      children: (
        <div>
          <div style={{ display: 'flex', justifyContent: 'right', marginTop: '24px' }}>
            <Form.Item>
              <Button
                onClick={ getDeployHistory1}
                style={{ marginRight: 8 }}
                theme={themeSettings}
                
              >
                {translation('Refresh')}
              </Button>
            </Form.Item>
            {formObject && formObject.Status === 'Registered' && formObject.Enabled ? (
              <Form.Item>
                <Button
                  theme={themeSettings}
                  
                  style={{ marginRight: 8 }}
                  type="primary"
                  onClick={() => setDeployModelVisible(true)}
                >
                  {translation('Deploy')}
                </Button>
              </Form.Item>
            ) : null}
          </div>
          <StyledTable size="small"
            pagination={pagination}
            onChange={handleTableChange}
            dataSource={Array.isArray(modelDeployHistoryData) ? modelDeployHistoryData : []}
            columns={ModelDeployHistoryColumns}
          />
        </div>
      ),
    },
    {
      key: 'Back test predictions',
      label: translation('Batch Inference'),
      children: (
        <div>
          <div style={{ display: 'flex', justifyContent: 'right', marginTop: '24px' }}>
            <Form.Item>
              <Button
                onClick={() => getPredictionHistory()}
                style={{ marginRight: 8 }}
                theme={themeSettings}
                
              >
                {translation('Refresh')}
              </Button>
            </Form.Item>
            {formObject && formObject.Status === 'Registered' && formObject.Enabled ? (
              <Form.Item>
                <Button
                  theme={themeSettings}
                  
                  style={{ marginRight: 8 }}
                  type="primary"
                 // disabled={
                    //   ModelDeployHistoryData &&
                    //   ModelDeployHistoryData.filter(
                    //     (item) =>
                    //       item.Default === true &&
                    //       item.Status === "Completed"
                    //   ).length === 0
                    //     ? true
                    //     : false
                    // }
                  onClick={() => {
                    let modelDetails = modelRef.current && modelRef.current.getFieldsValue();
                    let deploymentData = modelDeployHistoryData && Array.isArray(modelDeployHistoryData) && modelDeployHistoryData.filter(item => item.Default === true)[0];
                    predictionRequestRef.current && predictionRequestRef.current.setFieldsValue({});
                    deploymentData = {
                      CreatedTime: dayjs(deploymentData && deploymentData.CreatedTime).utc().local().format('YYYY-MM-DD HH:mm:ss'),
                      Virtualenv: deploymentData && deploymentData.Virtualenv
                    };
                    modelDetails = {
                      ...modelDetails,
                      ...deploymentData
                    };
                    predictionRequestRef.current && predictionRequestRef.current.setFieldsValue(ModelDetails);
                    setPredictionModel(true);
                    setPredictionRequestInfo(modelDetails);
                  }}
                >
                  {translation('New Request')}
                </Button>
              </Form.Item>
            ) : null}
            {selectedRowKeys && Array.isArray(selectedRowKeys) && selectedRowKeys.length !== 0 ? (
              <Form.Item>
                <Button
                  type="primary"
                  onClick={() => {
                    props.navigate('/rubus/RbsAnalytics/ModelComparision', {
                      state: {
                        ModelName_1: formObject && formObject['ModelName'] ? formObject['ModelName'] : '',
                        PredReqId_1: selectedRowKeys && Array.isArray(selectedRowKeys) && selectedRowKeys[0] ? selectedRowKeys[0] : '',
                        FromTime: selectedRows && selectedRows[0] && selectedRows[0].FromTime ? selectedRows[0].FromTime : '',
                        ToTime: selectedRows && selectedRows[0] && selectedRows[0].ToTime ? selectedRows[0].ToTime : ''
                      }
                    });
                  }}
                  style={{ marginRight: 8 }}
                  theme={themeSettings}
                  
                >
                  {translation('Compare Models')}
                </Button>
              </Form.Item>
            ) : null}
          </div>
          <StyledTable size="small"
            rowSelection={{
              type: 'radio',
              ...rowSelection
            }}
            pagination={pagination}
            onChange={handleTableChange}
            autoResetPage={false}
            dataSource={Array.isArray(modelPredHistoryData) ? modelPredHistoryData : []}
            columns={ModelPredHistoryColumns}
          />
        </div>
      ),
    },
    {
      key: 'Realtime Inference',
      label: translation('Real Time Inference'),
      children: (
        <div>
          <div style={{ display: 'flex', justifyContent: 'right' }}>
            <Form.Item>
              <Button
                onClick={getRealTimeRefreshHistory}
                style={{ marginRight: 8 }}
                theme={themeSettings}
                
              >
                {translation('Refresh')}
              </Button>
            </Form.Item>
            <Form.Item>
              <Button
                theme={themeSettings}
                
                style={{ marginRight: 8 }}
                type="primary"
                disabled={realTimeVal}
                onClick={onStartClick}
              >
                {translation('Start')}
              </Button>
            </Form.Item>
            <Form.Item>
              <Button
                theme={themeSettings}
                
                type="primary"
                onClick={() => setQuickRunModal(true)}
              >
                {translation('Quick Run')}
              </Button>
            </Form.Item>
            {selectedRowKeys && Array.isArray(selectedRowKeys) && selectedRowKeys.length !== 0 ? (
              <Form.Item>
                <Button
                  type="primary"
                  onClick={() => {
                    props.navigate('/rubus/RbsAnalytics/ModelComparision', {
                      state: {
                        ModelName_1: formObject && formObject['ModelName'] ? formObject['ModelName'] : '',
                        PredReqId_1: selectedRowKeys && Array.isArray(selectedRowKeys) && selectedRowKeys[0] ? selectedRowKeys[0] : '',
                        FromTime: selectedRows && selectedRows[0] && selectedRows[0].FromTime ? selectedRows[0].FromTime : '',
                        ToTime: selectedRows && selectedRows[0] && selectedRows[0].ToTime ? selectedRows[0].ToTime : ''
                      }
                    });
                  }}
                  style={{ marginLeft: 8 }}
                  theme={themeSettings}
                  
                >
                  {translation('Compare Models')}
                </Button>
              </Form.Item>
            ) : null}
          </div>
          <StyledTable size="small"
            rowSelection={{
              type: 'radio',
              ...rowSelectionRealTime
            }}
            pagination={pagination}
            onChange={handleRealtimeTableChange}
            autoResetPage={false}
            dataSource={Array.isArray(modelPredRealtimeHistoryData) ? modelPredRealtimeHistoryData : []}
            columns={ModelPredRealtimeColumns}
          />
        </div>
      ),
    }
  ];
  const items02 = [
    {
      key: 'Actions',
      label: translation('Actions'),
      children: (
        <div style={{ display: 'flex', flexWrap: 'wrap' }}>
          <Form.Item
            label={translation('Model Type')}
            name="ModelType"
            style={formItemLayout}
          >
            <Input
              defaultValue={modelType}
              style={{ width: '70%' }}
              disabled
            />
          </Form.Item>
          <Form.Item
            label={translation('Model Name')}
            name="ModelName"
            style={formItemLayout}
          >
            <Input
              defaultValue={modelName}
              style={{ width: '70%' }}
              disabled
            />
          </Form.Item>
          {formObject && formObject.modelType === 'Classification' ? (
            <>
              <Form.Item
                label={translation('Condition')}
                name="Operator"
                style={formItemLayout}
              >
                <Select
                  disabled={buttonKey === 'stop' ? true : false}
                  onChange={onConditionChange}
                  style={{ width: '70%' }}
                  placeholder={translation('Please Select Condition')}
                  //  disabled={AddConditionFormDisable}
                >
                  <Option value="==">{'EqualTo (==)'}</Option>
                  <Option value="!=">{'Not EqualTo (!=)'}</Option>
                </Select>
              </Form.Item>
              <Form.Item
                label={translation('Value')}
                name="Value"
                style={formItemLayout}
              >
                <Select
                  style={{ width: '70%' }}
                  placeholder={translation('Please Select Value')}
                  disabled={buttonKey === 'stop'}
                >
                  <Option value="NORMAL">NORMAL</Option>
                  <Option value="ABNORMAL">ABNORMAL</Option>
                </Select>
              </Form.Item>
            </>
          ) : null}
          {formObject && formObject.modelType === 'Regression' ? (
            <>
              <Form.Item
                label={translation('Condition')}
                name="Operator"
                style={formItemLayout}
              >
                <Select
                  placeholder={translation('Select Condition')}
                  style={{ width: '70%' }}
                  onChange={onConditionChange}
                  disabled={buttonKey === 'stop'}
                >
                  <Option value="<">{'Less Than (<)'}</Option>
                  <Option value=">">{'Greater Than (>)'}</Option>
                  <Option value=">=">{'Greater Than Or EqualTo (>=)'}</Option>
                  <Option value="<=">{'Less Than Or EqualTo (<=)'}</Option>
                  <Option value="Between">Between</Option>
                </Select>
              </Form.Item>
              {selectedCondition === 'Between' ? (
                <>
                  <Form.Item
                    label={translation('Value')}
                    name="Value"
                    style={{ width: '100px', flex: '50%' }}
                  >
                    <Space.Compact>
                      <Form.Item>
                        <Input
                          placeholder={translation('Min Value')}
                          step="0.1"
                          min="0"
                          max="100"
                          type="number"
                          name="value1"
                          style={{ width: 100 }}
                          onChange={onValueChange1}
                          disabled={buttonKey === 'stop'}
                        />
                      </Form.Item>
                      <Form.Item
                        style={{
                          width: 20
                        }}
                        disabled
                      >
                        <SwapOutlined />
                      </Form.Item>
                      <Form.Item>
                        <Input
                          placeholder={translation('Max Value')}
                          step="0.1"
                          min="0"
                          max="100"
                          style={{ width: 100 }}
                          type="number"
                          name="value2"
                          onChange={onValueChange2}
                          disabled={buttonKey === 'stop'}
                        />
                      </Form.Item>
                    </Space.Compact>
                  </Form.Item>
                </>
              ) : (
                <>
                  <Form.Item
                    label={translation('Value')}
                    name="Value"
                    style={formItemLayout}
                  >
                    <Input
                      placeholder={translation('Please Select Value')}
                      step="0.1"
                      min="0"
                      max="100"
                      name="value"
                      type="number"
                      onChange={onValueChange}
                      style={{ width: '70%' }}
                      disabled={buttonKey === 'stop'}
                    />
                  </Form.Item>
                </>
              )}
            </>
          ) : null}
          <Form.Item
            label={translation('Communication Type')}
            name="CommunicationTypes"
            style={formItemLayout}
          >
            <ActionCheckbox
              disabled={buttonKey === 'stop'}
              options={data}
              value={selectedCommunication}
              onChange={(checkedValues) => {
                checkOnChange(checkedValues, 'CommunicationTypes');
              }}
            />
          </Form.Item>
          <Form.Item
            label={translation('Mail Recipient')}
            name="MailRecipient"
            style={formItemLayout}
          >
            <Select
              disabled={buttonKey === 'stop'}
              placeholder={translation('RecipientList')}
              mode="multiple"
              value={mailRecipient}
              style={{ width: '70%', display: 'inline-block' }}
              onChange={(value) => handleRecipientList(value, 'mailRecipients')}
            >
              {recipientlist && Array.isArray(recipientlist) && recipientlist.map((item, index) => (
                <Option key={index} value={item.Email}>
                  {item.FirstName} {item.LastName}
                </Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            label={translation('Status')}
            name="Status"
            style={formItemLayout}
          >
            <Checkbox
              disabled={buttonKey === 'stop'}
              onChange={onStatusCheck}
              checked={status}
              style={{ width: '70%' }}
            />
          </Form.Item>
        </div>
      ),
    }
  ];
  const items03 = [
    {
      key: 'Metric values',
      label: translation('Metric Values'),
      children: (
        <div className="site-card-wrapper" style={{ marginTop: '24px' }}>
          <Row gutter={16}>
            <Col span={8}>
              <Card title={translation('Metric Values')} bordered={false}>
                <StyledTable size="small"
                  pagination={{
                    defaultPageSize: 10,
                    hideOnSinglePage: true
                  }}
                  dataSource={Array.isArray(metricValuesData) ? metricValuesData : []}
                  columns={metricResultColumns}
                />
              </Card>
            </Col>
            {Array.isArray(metricImagesData) && metricImagesData.map((item, index) => (
              <Col key={index} span={8}>
                <Card title={translation(item.metricCode)} bordered={false}>
                  <Image
                    width={500}
                    src={`http://192.168.95.23:3001/api/analyticsAttachments/${item.MetricValue.split('/')[0]}/${item.MetricValue.split('/')[1]}`}
                    alt={item.metricCode}
                  />
                </Card>
              </Col>
            ))}
          </Row>
        </div>
      ),
    },
    {
      key: 'Prediction results',
      label: translation('Inference Results'),
      children: (
        <div>
          <Form ref={predResRef} initialValues={predResInfo}>
            <div style={{ display: 'flex', justifyContent: 'right', marginTop: '24px' }}>
              <Form.Item name="FromTime" label={translation('Prediction From')}>
                <Input disabled />
              </Form.Item>
              <Form.Item name="ToTime" label={translation('Prediction To')}>
                <Input disabled />
              </Form.Item>
              <Form.Item name="Date" label={translation('Select Range')}>
                <RangePicker
                  format="YYYY-MM-DD HH:mm:ss"
                  showTime={{ format: "HH:mm:ss" }}
                  onChange={(e) => {
                    dateRangePicker(e, 'Date');
                  }}
                  disabledDate={(d) => 
                      //     formHeader.current.getFieldValue("EndTime")
                      //                 ? moment(formHeader.current.getFieldValue("EndTime")).add(1, "day").format("YYYY-MM-DD") : ""
                      //         ))
                    !d || 
                    d.isAfter(predictionToTime ? dayjs(predictionToTime).add(1, 'day') : '') || 
                    d.isBefore(predictionFromTime ? dayjs(predictionFromTime) : '')
                  }
                  // disabledTime={(e) =>
                  //   getDisabledHours(
                  //     dayjs(e, 'YYYY-MM-DD HH:mm:ss'),
                  //     predictionFromTime,
                  //     predictionToTime
                  //   )
                  // }
                />
              </Form.Item>
              <Form.Item name="PredReqId"></Form.Item>
            </div>
          </Form>
          <StyledTable size="small"
            showSizeChanger={false}
            onChange={handleTableChange}
            pagination={{ pageSize: 10 }}
            dataSource={Array.isArray(predictionResultsData) ? predictionResultsData : []}
            columns={predResRef.current && predResRef.current.getFieldsValue().modelType === 'Classification' ? predictionCLFResultColumns : predictionREGResultColumns}
          />
        </div>
      ),
    },
    {
      key: 'Trends',
      label: translation('Trends'),
      children: (
        <div>
          <StyledForm
            name="ModelDetails"
            ref={trendRef}
            autoComplete="off"
            initialValues={trendObj}
            theme={themeSettings}
            layout="horizontal"
            labelCol={{ flex: '200px' }}
            labelAlign="right"
            onFinish={onTrendSubmit}
            onFinishFailed={onFinishFailed}
            labelWrap
            validateMessages={validateMessages}
            wrapperCol={{ flex: 1 }}
          >
            <div style={{ display: 'flex', flexWrap: 'wrap', marginTop: '24px' }}>
              <Form.Item
                name="FromDate"
                label={translation('Data From')}
                style={formItemLayout}
              >
                <DatePicker
                  allowClear={false}
                  style={{ width: '70%' }}
                  format="YYYY-MM-DD HH:mm:ss"
                  showTime={{ format: "HH:mm:ss" }}
                  disabledDate={(d) => 
                    !d || 
                    d.isAfter(trendObj.CurrentTime ? dayjs(trendObj.CurrentTime).add(1, 'day') : '')
                  }
                  // disabledTime={(e) =>
                  //   getDisabledTrendHours(
                  //     dayjs(e, 'YYYY-MM-DD HH:mm:ss'),
                  //     trendObj.CurrentTime,
                  //     'start'
                  //   )
                  // }
                />
              </Form.Item>
              <Form.Item
                name="ToDate"
                label={translation('Data To')}
                style={formItemLayout}
              >
                <DatePicker
                  allowClear={false}
                  style={{ width: '70%' }}
                  format="YYYY-MM-DD HH:mm:ss"
                  showTime={{ format: "HH:mm:ss" }}
                  disabledDate={(d) => 
                    !d || 
                    d.isBefore(trendObj.CurrentTime ? dayjs(trendObj.CurrentTime).add(1, 'day') : '')
                  }
                  // disabledTime={(e) =>
                  //   getDisabledTrendHours(
                  //     dayjs(e, 'YYYY-MM-DD HH:mm:ss'),
                  //     trendObj.CurrentTime,
                  //     'end'
                  //   )
                  // }
                />
              </Form.Item>
              {trendObj && trendObj.CurrentTime ? (
                <>
                  <Form.Item
                    name="PredictionTargetFrom"
                    label={translation('Prediction Target From')}
                    style={formItemLayout}
                  >
                    <Input disabled style={{ width: '70%' }} />
                  </Form.Item>
                  <Form.Item
                    name="PredictionTargetTo"
                    label={translation('Prediction Target To')}
                    style={formItemLayout}
                  >
                    <Input disabled style={{ width: '70%' }} />
                  </Form.Item>
                </>
              ) : null}
              {trendObj && trendObj.CurrentTime ? (
                <Form.Item
                  name="CurrentTime"
                  label={translation('Predicted At')}
                  style={formItemLayout}
                >
                  <DatePicker
                    style={{ width: '70%' }}
                    format="YYYY-MM-DD HH:mm:ss"
                    disabled
                    showTime={{ format: "HH:mm:ss" }}
                    allowClear={false}
                  />
                </Form.Item>
              ) : null}
              <Form.Item
                name={'Interval'}
                label={translation('Interval')}
                rules={[{ required: true }]}
                style={formItemLayout}
              >
                <Select style={{ width: '70%' }} disabled>
                  {Array.isArray(intervalData) && intervalData.map((item, index) => (
                    <Option key={index} value={item.value}>
                      {item.key}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item
                label={translation('Device')}
                name="DeviceCode"
                rules={[{ required: true }]}
                style={formItemLayout}
              >
                <Select
                  mode="multiple"
                  style={{ width: '70%' }}
                  onChange={(e) => {
                    deviceOnChange(e, formObject);
                  }}
                  disabled
                >
                  {Array.isArray(deviceList) && deviceList.map((item) => (
                    <Option key={item.device} value={item.device}>
                      {item.device}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item
                label={translation('Parameters')}
                name="ParameterCode"
                rules={[{ required: true }]}
                style={formItemLayout}
              >
                <Select
                  mode="multiple"
                  style={{ width: '480px' }}
                  onChange={(e) => {
                    onParameterChange(e);
                  }}
                >
                  {Array.isArray(parameterList) && parameterList.map((item) => (
                    <Option key={item.device} value={item.parameterCode}>
                      {item.device}@{item.parameterName}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </div>
            <div style={{ display: 'flex', justifyContent: 'right' }}>
              <Button theme={themeSettings} type="primary" htmlType="submit">
                {translation('Generate Trend')}
              </Button>
            </div>
          </StyledForm>
          <div style={{ display: 'flex', flexWrap: 'wrap', marginTop: '24px' }}>
            {Array.isArray(trendData) && trendData.map((graphData, i) => (
              <div key={i} style={{ width: '48%', height: '48vh', marginTop: '1%' }}>
                {Array.isArray(graphData) && graphData.length > 0 ? (
                  <TrendSlider
                    panelData={{
                      graph: 'trends',
                      trendData: graphData,
                      colors: [color[i]],
                      linetype: '',
                   //   update: update,
                      type: 'line',
                      trendObj: trendObj,
                      formObject: formObject
                    }}
                  />
                ) : null}
              </div>
            ))}
          </div>
        </div>
      ),
    },
    {
      key: 'Functional summary',
      label: translation('Functional Summary'),
      children: (
        <div>
          <Row>
            <Col span={10}>
              <Title level={4} style={{  width: '800px' }}>
                {'Main stream temperature(>428) daily Anomaly count- Predicted Vs Actual(%)'}
              </Title>
            </Col>
            <Col span={6}></Col>
            <Col span={8}>
              <Form.Item
                style={{ marginRight: '0px' }}
                label={translation('Select Date Range')}
              >
                <RangePicker
                  allowClear={false}
                  disabledDate={(d) => 
                    !d || 
                    d.isAfter(predictionToTime ? dayjs(predictionToTime) : '') || 
                    d.isBefore(predictionFromTime ? dayjs(predictionFromTime) : '')
                  }
                  value={[
                    dayjs(functionalSummaryDailyFrom, 'YYYY-MM-DD 00:00:00'),
                    dayjs(functionalSummaryDailyTo, 'YYYY-MM-DD 23:59:59')
                  ]}
                  onChange={(date) => 
                    getDailyFunctionalSummary(
                      dayjs(date[0]).utc().local().format('YYYY-MM-DD 00:00:00'),
                      dayjs(date[1]).utc().local().format('YYYY-MM-DD 23:59:59'),
                      'date'
                    )
                  }
                />
              </Form.Item>
            </Col>
          </Row>
          <div key={0} style={{ width: '48%', height: '48vh', marginTop: '1%' }}>
            {Array.isArray(dailyFunctionalSummary) && dailyFunctionalSummary.length > 0 ? (
              <FunctionalSummary
                panelData={{
                  graph: 'trends',
                  trendData: dailyFunctionalSummary,
                  linetype: '',
               //   update: update,
                  type: 'bar',
                  formObject: formObject
                }}
              />
            ) : null}
          </div>
          <Row>
            <Col span={11}>
              <Title level={4} style={{  width: '800px' }}>
                {'Main stream temperature(>428) weekly Anomaly count- Predicted Vs Actual(%)'}
              </Title>
            </Col>
            <Col span={4}></Col>
            <Col span={9}>
              <Form.Item label={translation('As On Date')}>
                <Input.Group compact>
                  <DatePicker
                    disabledDate={(d) => 
                      !d || 
                      d.isAfter(predictionToTime ? dayjs(predictionToTime).add(1, 'day') : '') || 
                      d.isBefore(predictionFromTime ? dayjs(predictionFromTime) : '')
                    }
                    value={dayjs(functionalSummaryWeeklyTo, 'YYYY-MM-DD HH:mm:ss')}
                    onChange={(date) => 
                      getweeklyFunctionalSummary(
                        dayjs(date).utc().local().format('YYYY-MM-DD 23:59:59'),
                        functionalSummaryWeekCount
                      )
                    }
                    allowClear={false}
                  />
                  <Form.Item rules={[{ required: true }]}>
                    <Input
                      style={{
                        width: 100,
                        borderLeft: 0,
                        borderRight: 0,
                        pointerEvents: 'none'
                      }}
                      placeholder={translation('Last')}
                      disabled
                    />
                  </Form.Item>
                  <InputNumber
                    onChange={(value) => 
                      getweeklyFunctionalSummary(functionalSummaryWeeklyTo, value)
                    }
                    value={functionalSummaryWeekCount}
                  />
                  <Form.Item rules={[{ required: true }]}>
                    <Input
                      style={{
                        width: 80,
                        borderLeft: 0,
                        borderRight: 0,
                        pointerEvents: 'none'
                      }}
                      placeholder={translation('Weeks')}
                      disabled
                    />
                  </Form.Item>
                </Input.Group>
              </Form.Item>
            </Col>
          </Row>
          <div key={1} style={{ width: '48%', height: '48vh', marginTop: '1%' }}>
            {Array.isArray(weeklyFunctionalSummary) && weeklyFunctionalSummary.length > 0 ? (
              <FunctionalSummary
                panelData={{
                  graph: 'trends',
                  trendData: weeklyFunctionalSummary,
                  linetype: '',
               //   update: update,
                  type: 'bar',
                  formObject: formObject
                }}
              />
            ) : null}
          </div>
        </div>
      ),
    }
  ];
  const items04 = [
    {
      key: 'Metric values',
      label: translation('Metric Values'),
      children: (
        <div className="site-card-wrapper">
          <Row gutter={16}>
            <StyledForm
              name="RealTime Prediction Request"
              ref={realTimePredictionRequestRef}
              autoComplete="off"
              initialValues={realTimePredictionRequestInfo || {}}
              theme={themeSettings}
              layout="horizontal"
              labelCol={{ flex: '200px' }}
              labelAlign="right"
              onFinish={onRealTimePredictionRequestSubmit}
              onFinishFailed={onFinishFailed}
              labelWrap
              validateMessages={validateMessages}
              wrapperCol={{ flex: 1 }}
            >
              <div style={{ display: 'flex', flexWrap: 'wrap', marginTop: '50px' }}>
                <Form.Item
                  name="FromTime"
                  label={translation('Start Time')}
                  rules={[{ required: true }]}
                  style={formItemLayout}
                >
                  <DatePicker
                    allowClear={false}
                    showTime={{ format: 'HH:mm:ss' }}
                    format="YYYY-MM-DD HH:mm:ss"
                    value={realTimePredictionRequestInfo.FromTime}
                    onOk={(date) => handleMetricDateInputChange(date)}
                    disabledDate={(d) =>
                      !d ||
                      d.isAfter(
                        realTimePredictionRequestRef.current?.getFieldValue('ToTime')
                          ? dayjs(realTimePredictionRequestRef.current.getFieldValue('ToTime')).format('YYYY-MM-DD HH:mm:ss')
                          : ''
                      )
                    }
                  />
                </Form.Item>
                <Form.Item
                  name="ToTime"
                  label={translation('End Time')}
                  rules={[{ required: true }]}
                  style={formItemLayout}
                >
                  <DatePicker
                    allowClear={false}
                    showTime={{ format: 'HH:mm:ss' }}
                    format="YYYY-MM-DD HH:mm:ss"
                    onOk={(date) => handleMetricDateInputChange(date)}
                    disabledDate={(d) =>
                      !d ||
                      d.isBefore(
                        realTimePredictionRequestRef.current?.getFieldValue('FromTime')
                          ? dayjs(realTimePredictionRequestRef.current.getFieldValue('FromTime')).format('YYYY-MM-DD HH:mm:ss')
                          : ''
                      ) &&
                      d.isBefore(dayjs().format('YYYY-MM-DD HH:mm:ss'))
                    }
                    disabledTime={(current) => {
                      let FromTime = realTimePredictionRequestRef.current?.getFieldValue('FromTime');
                      let currentTime = dayjs();
                      if (!FromTime || !current) {
                        return {};
                      }
                      const disabledHours = [];
                      const disabledMinutes = [];
                      const disabledSeconds = [];
                      if (current.isSame(FromTime, 'day')) {
                        for (let i = 0; i < FromTime.hour(); i++) {
                          disabledHours.push(i);
                        }
                        if (current.hour() === FromTime.hour()) {
                          for (let i = 0; i < FromTime.minute(); i++) {
                            disabledMinutes.push(i);
                          }
                          if (current.minute() === FromTime.minute()) {
                            for (let i = 0; i < FromTime.second(); i++) {
                              disabledSeconds.push(i);
                            }
                          }
                        }
                      }
                      if (current.isSame(currentTime, 'day')) {
                        for (let i = 0; i < currentTime.hour(); i++) {
                          disabledHours.push(i);
                        }
                        if (current.hour() === currentTime.hour()) {
                          for (let i = 0; i < currentTime.minute(); i++) {
                            disabledMinutes.push(i);
                          }
                          if (current.minute() === currentTime.minute()) {
                            for (let i = 0; i < currentTime.second(); i++) {
                              disabledSeconds.push(i);
                            }
                          }
                        }
                      }
                      return {
                        disabledHours: () => disabledHours,
                        disabledMinutes: () => disabledMinutes,
                        disabledSeconds: () => disabledSeconds,
                      };
                    }}
                  />
                </Form.Item>
                <Form.Item
                  name="Metrics"
                  label={translation('Metrics')}
                  rules={[{ required: true }]}
                  style={formItemLayout}
                >
                  <Tree
                    checkable
                    onCheck={(e) => onMetricCheck('Metrics', e)}
                    switcherIcon={<DownOutlined />}
                    checkedKeys={
                      realTimePredictionRequestInfo &&
                        realTimePredictionRequestInfo['Metrics']
                        ? realTimePredictionRequestInfo['Metrics']
                        : ''
                    }
                  >
                    {renderTreeNodes(metricsData)}
                  </Tree>
                </Form.Item>
                <div style={{ display: 'flex', justifyContent: 'right', marginTop: '200px' }}>
                  <Form.Item>
                    <Button ref={predictionButtonRef} htmlType="submit" type="primary">
                      {translation('Submit')}
                    </Button>
                  </Form.Item>
                </div>
              </div>
            </StyledForm>
            {realTimeMetricResultVisible && (
              <>
                {metricValuesData1 && Array.isArray(metricValuesData1) ? (
                  <Col span={8}>
                    <Card title={translation('Metric Values')} bordered={false}>
                      <StyledTable size="small"
                        pagination={{
                          defaultPageSize: 10,
                          hideOnSinglePage: true,
                        }}
                        dataSource={metricValuesData1}
                        columns={RealTimeMetricResultColumns}
                      />
                    </Card>
                  </Col>
                ) : null}
                {confMatrixVisible && (
                  <Col span={8}>
                    <Card title={translation('Confusion Matrix')} bordered={false}>
                      <ReactEcharts
                        option={option}
                        style={{
                          height: '450%',
                          width: '100%',
                        }}
                        className="react_for_echarts"
                      />
                    </Card>
                  </Col>
                )}
                {rocCurveVisible && (
                  <Col span={8}>
                    <Card title={translation('ROC Curve')} bordered={false}>
                      <ReactEcharts
                        option={rocCurveOption}
                        style={{
                          height: '450%',
                          width: '100%',
                        }}
                        className="react_for_echarts"
                      />
                    </Card>
                  </Col>
                )}
              </>
            )}
          </Row>
        </div>
      ),
    },
    {
      key: 'RealTimeInferenceResults',
      label: translation('Real Time Inference Results'),
      children: (
        <div>
          <Form ref={realTimePredResRef} initialValues={realTimePredResInfo}>
            <div style={{ display: 'flex', justifyContent: 'right' }}>
              <Form.Item name="FromTime" label={translation('Prediction From')}>
                <Input disabled />
              </Form.Item>
              <Form.Item name="ToTime" label={translation('Prediction To')}>
                <Input disabled />
              </Form.Item>
              <Form.Item name="Date" label={translation('Select Range')}>
                <RangePicker
                  format="YYYY-MM-DD HH:mm:ss"
                  showTime={{ format: 'HH:mm:ss' }}
                  onChange={(e) => {
                    realTimeDateRangePicker(e, 'Date');
                  }}
                  disabledDate={(d) =>
                    !d ||
                    d.isAfter(predictionToTime ? dayjs(predictionToTime).add(1, 'day').format('YYYY-MM-DD HH:mm:ss') : '') ||
                    d.isBefore(predictionFromTime ? dayjs(predictionFromTime).format('YYYY-MM-DD HH:mm:ss') : '')
                  }
                />
              </Form.Item>
              <Form.Item name="PredReqId"></Form.Item>
            </div>
          </Form>
          <StyledTable size="small"
            showSizeChanger={false}
            pagination={pagination}
            onChange={handleTableChange}
            dataSource={realPredictionResultsData && Array.isArray(realPredictionResultsData) ? realPredictionResultsData : []}
            columns={modelRef.current?.getFieldsValue().modelType === 'Classification' ? realTimePredictionCLFResultColumns : predictionREGResultColumns}
          />
        </div>
      ),
    },
    {
      key: 'Trends',
      label: translation('Trends'),
      children: (
        <div>
          <StyledForm
            name="ModelDetails"
            ref={realTimeTrendRef}
            autoComplete="off"
            initialValues={trendObj}
            theme={themeSettings}
            layout="horizontal"
            labelCol={{ flex: '200px' }}
            labelAlign="right"
            onFinish={onTrendSubmitRealTime}
            onFinishFailed={onFinishFailed}
            labelWrap
            validateMessages={validateMessages}
            wrapperCol={{ flex: 1 }}
          >
            <div style={{ display: 'flex', flexWrap: 'wrap' }}>
              <Form.Item
                name="FromDate"
                label={translation('Data From')}
                style={formItemLayout}
              >
                <DatePicker
                  allowClear={false}
                  style={{ width: '70%' }}
                  format="YYYY-MM-DD HH:mm:ss"
                  showTime={{ format: "HH:mm:ss" }}
                  disabledDate={(d) =>
                    !d ||
                    d.isAfter(trendObj.CurrentTime ? dayjs(trendObj.CurrentTime).add(1, 'day').format('YYYY-MM-DD') : '')
                  }
                />
              </Form.Item>
              <Form.Item
                name="ToDate"
                label={translation('Data To')}
                style={formItemLayout}
              >
                <DatePicker
                  allowClear={false}
                  style={{ width: '70%' }}
                  format="YYYY-MM-DD HH:mm:ss"
                  showTime={{ format: "HH:mm:ss" }}
                  disabledDate={(d) =>
                    !d ||
                    d.isBefore(trendObj.CurrentTime ? dayjs(trendObj.CurrentTime).add(1, 'day').format('YYYY-MM-DD') : '')
                  }
                />
              </Form.Item>
              {trendObj && trendObj.CurrentTime ? (
                <>
                  <Form.Item
                    name="PredictionTargetFrom"
                    label={translation('Prediction Target From')}
                    style={formItemLayout}
                  >
                    <Input disabled style={{ width: '70%' }} />
                  </Form.Item>
                  <Form.Item
                    name="PredictionTargetTo"
                    label={translation('Prediction Target To')}
                    style={formItemLayout}
                  >
                    <Input disabled style={{ width: '70%' }} />
                  </Form.Item>
                </>
              ) : null}
              {trendObj && trendObj.CurrentTime ? (
                <Form.Item
                  name="CurrentTime"
                  label={translation('Predicted At')}
                  style={formItemLayout}
                >
                  <DatePicker
                    style={{ width: '70%' }}
                    format="YYYY-MM-DD HH:mm:ss"
                    disabled
                    showTime={{ format: "HH:mm:ss" }}
                    allowClear={false}
                  />
                </Form.Item>
              ) : null}
              <Form.Item
                style={formItemLayout}
                name={'Interval'}
                label={translation('Interval')}
                rules={[{ required: true }]}
              >
                <Select style={{ width: '70%' }} disabled>
                  {Array.isArray(intervalData) && intervalData.map((item, index) => (
                    <Option key={index} value={item.value}>
                      {item.key}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item
                label={translation('Device')}
                name="DeviceCode"
                rules={[{ required: true }]}
                style={formItemLayout}
              >
                <Select
                  mode="multiple"
                  style={{ width: '70%' }}
                  onChange={(e) => {
                    deviceOnChange(e, formObject);
                  }}
                  disabled
                >
                  {Array.isArray(deviceList) && deviceList.map((item) => (
                    <Option key={item.device} value={item.device}>
                      {item.device}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item
                label={translation('Parameters')}
                name="ParameterCode"
                rules={[{ required: true }]}
                style={formItemLayout}
              >
                <Select
                  mode="multiple"
                  style={{ width: '480px' }}
                  onChange={(e) => onParameterChange(e)}
                >
                  {Array.isArray(parameterList) && parameterList.map((item) => (
                    <Option key={item.Device} value={item.parameterCode}>
                      {item.Device}@{item.parameterName}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </div>
            <div style={{ display: 'flex', justifyContent: 'right' }}>
              <Button theme={themeSettings} type="primary" htmlType="submit">
                {translation('Generate Trend')}
              </Button>
            </div>
          </StyledForm>
                  <div>
          {/* <div style={{ display: 'flex', flexWrap: 'wrap' }}> */}
          {trendData &&
                Array.isArray(trendData) &&
                trendData.map((graphData, i) => {
                  return (
                    <div
                      key={i}
                      style={{
                        width: '48%',
                        height: '48vh',
                        marginTop: '1%'
                      }}
                    >
                      {graphData && Array.isArray(graphData) && graphData.length > 0 ? (
                        <TrendSlider
                          panelData={{
                            graph: 'trends',
                            trendData: graphData,
                            colors: [color[i]],
                            linetype: '',
                        //    update: update,
                            type: 'line',
                            trendObj: trendObj,
                            formObject: formObject
                          }}
                        />
                      ) : null}
                    </div>
                  );
                })}
            </div>
          </div>
        ),
      },
  {
    key: 'Functional summary',
    label: translation('Functional Summary'),
    children: (
      <div>
        {/* <div className="App">
              <ViewDashboard name="Prediction" />
            </div> */}
        <Row>
          <Col span={10}>
            {' '}
            <Title
              level={4}
              style={{  width: '800px' }}
            >
              {'Main steam temperature(>428) daily Anomaly count- Predicted Vs Actual(%)'}
            </Title>
          </Col>
          <Col span={6}></Col>
          <Col span={8}>
            {' '}
            <Form.Item
              style={{ marginRight: '0px' }}
              label={translation('Select Date Range')}
            >
              <RangePicker
                allowClear={false}
                disabledDate={(d) =>
                  //     formHeader.current.getFieldValue("EndTime")
                  //                 ? moment(formHeader.current.getFieldValue("EndTime")).add(1, "day").format("YYYY-MM-DD") : ""
                  //         ))
                  !d ||
                  d.isAfter(
                    predictionToTime ? dayjs(predictionToTime).format('YYYY-MM-DD') : ''
                  ) ||
                  d.isBefore(
                    predictionFromTime ? dayjs(predictionFromTime).format('YYYY-MM-DD') : ''
                  )
                }
                value={[
                  dayjs(functionalSummaryDailyFrom1, 'YYYY-MM-DD 00:00:00'),
                  dayjs(functionalSummaryDailyTo1, 'YYYY-MM-DD 23:59:59')
                ]}
                onChange={(date) =>
                  getRealTimeDailyFunctionalSummary(
                    dayjs(date[0]).utc().local().format('YYYY-MM-DD 00:00:00'),
                    dayjs(date[1]).utc().local().format('YYYY-MM-DD 23:59:59'),
                    'date'
                  )
                }
              ></RangePicker>
            </Form.Item>
          </Col>
        </Row>
        <div
          key={0}
          style={{
            width: '48%',
            height: '48vh',
            marginTop: '1%'
          }}
        >
          {dailyFunctionalSummary1 &&
            Array.isArray(dailyFunctionalSummary1) &&
            dailyFunctionalSummary1.length > 0 ? (
            <FunctionalSummary
              panelData={{
                graph: 'trends',
                trendData: dailyFunctionalSummary1,
                linetype: '',
               // update: update,
                type: 'bar',
                formObject: formObject
              }}
            />
          ) : null}
        </div>
        <Row>
          <Col span={11}>
            <Title
              level={4}
              style={{  width: '800px' }}
            >
              {'Main stream temperature(>428) weekly Anomaly count- Predicted Vs Actual(%)'}
            </Title>
          </Col>
          <Col span={4}></Col>
          <Col span={9}>
            <Form.Item label={translation('As On Date')}>
              <Space.Compact>
                <DatePicker
                  disabledDate={(d) =>
                    !d ||
                    d.isAfter(
                      predictionToTime
                        ? dayjs(predictionToTime).add(1, 'day').format('YYYY-MM-DD')
                        : ''
                    ) ||
                    d.isBefore(
                      predictionFromTime
                        ? dayjs(predictionFromTime).format('YYYY-MM-DD')
                        : ''
                    )
                  }
                  value={dayjs(functionalSummaryWeeklyTo1, 'YYYY-MM-DD HH:mm:ss')}
                  onChange={(date) =>
                    getRealTimeweeklyFunctionalSummary(
                      moment(date).utc().local().format('YYYY-MM-DD 23:59:59'),
                      functionalSummaryWeekCount1
                    )
                  }
                  allowClear={false}
                ></DatePicker>
                <Form.Item rules={[{ required: true }]}>
                  <Input
                    style={{
                      width: 80,
                      borderLeft: 0,
                      borderRight: 0,
                      pointerEvents: 'none'
                    }}
                    placeholder={translation('Last')}
                    disabled
                  />
                </Form.Item>
                <InputNumber
                  onChange={(value) =>
                    getRealTimeweeklyFunctionalSummary(functionalSummaryWeeklyTo1, value)
                  }
                  value={functionalSummaryWeekCount1}
                />
                <Form.Item rules={[{ required: true }]}>
                  <Input
                    style={{
                      width: 80,
                      borderLeft: 0,
                      borderRight: 0,
                      pointerEvents: 'none'
                    }}
                    placeholder={translation('Weeks')}
                    disabled
                  />
                </Form.Item>
              </Space.Compact>
            </Form.Item>
          </Col>
        </Row>
        <div
          key={1}
          style={{
            width: '48%',
            height: '48vh',
            marginTop: '1%'
          }}
        >
          {weeklyFunctionalSummary1 &&
            Array.isArray(weeklyFunctionalSummary1) &&
            weeklyFunctionalSummary1.length > 0 ? (
            <FunctionalSummary
              panelData={{
                graph: 'trends',
                trendData: weeklyFunctionalSummary1,
                linetype: '',
              //  update:update,
                type: 'bar',
                formObject: formObject
              }}
            />
                ) : null}
              </div>
              <Row>
              <Col span={10}>
                {' '}
                <Title
                  level={4}
                  style={{  width: '800px' }}
                >
                  {'Main steam temperature(>428) Real Time Anomaly count- Predicted Vs Actual(%)'}
                </Title>
              </Col>
              <Col span={6}></Col>
              <Col span={8}>
                {' '}
                {/* <Form.Item
                      style={{ marginRight: '0px' }}
                      label={translation('Select Date Range')}
                    > */}
                <Form.Item>
                  <RangePicker
                    format="YYYY-MM-DD HH:mm:ss"
                    showTime={{ format: 'HH:mm:ss' }}
                    placeholder={['Start Date', 'End Date']}
                    onChange={onChange}
                    ranges={{
                      Today: [dayjs().startOf('day'), dayjs()],
                      'This Month': [dayjs().startOf('month'), dayjs()],
                      'Last Month': [
                        dayjs().subtract(1, 'month').startOf('month'),
                        dayjs().subtract(1, 'month').endOf('month')
                      ]
                    }}
                    value={momentRange}
                    disabledDate={
                      (d) =>
                        //     formHeader.current.getFieldValue("EndTime")
                        //                 ? moment(formHeader.current.getFieldValue("EndTime")).add(1, "day").format("YYYY-MM-DD") : ""
                        //         ))
                        !d ||
                        d.isAfter(
                          functionalSummaryTo
                            ? dayjs(functionalSummaryTo).format('YYYY-MM-DD HH:mm:ss')
                            : ''
                        )
                      //  ||
                      // d.isBefore(
                      //   predictionFromTime
                      //     ? moment(predictionFromTime).format('YYYY-MM-DD HH:mm:ss')
                      //     : ''
                      // )
                    }
                    // onOk={onOkfun}
                    style={{
                      width: '400px',
                      cursor: 'pointer'
                    }}
                  />
                </Form.Item>
                {/* </Form.Item> */}
              </Col>
            </Row>
            <div
              key={0}
              style={{
                width: '48%',
                height: '48vh',
                marginTop: '1%'
              }}
            >
              {realTimeFunctionalSummary &&
                Array.isArray(realTimeFunctionalSummary) &&
                realTimeFunctionalSummary.length > 0 ? (
                <RealTimeGraph
                  difMin={difMin}
                  differenceHours={differenceHours}
                  disableGraph={disableGraph}
                  panelData={{
                    GraphData: realTimeFunctionalSummary,
                    selectionDateRange: selectionDateRange,
                    PredReqId: realTimePredictionReqInfo.PredReqId,
                    FromTime: realTimePredictionReqInfo.FromTime,
                    ToTime: realTimePredictionReqInfo.ToTime
                  }}
                />
              ) : null}
          </div>
        </div>
      ),
    },
    {
      key: 'Actions History',
      label: translation('Actions History'),
      children: (
        <StyledTable size="small"
          style={{ marginTop: '10px' }}
          pagination={pagination}
          onChange={handleTableChange}
          dataSource={actionsLogDataSource &&Array.isArray(actionsLogDataSource &&actionsLogDataSource) ? actionsLogDataSource : []}
          columns={actionsHistoryColumns}
        />
      ),
    },
  ];
    return (
      < >
        {/* =========== Main Form of Model Details ============ */}
        <StyledForm
        name="ModelDetails"
        ref={modelRef}
        autoComplete="off"
        initialValues={formObject}
        theme={themeSettings}
        layout="horizontal"
        labelCol={{ flex: '200px' }}
        labelAlign="right"
        onFinish={onFormSubmit}
        onFinishFailed={onFinishFailed}
        labelWrap
        validateMessages={validateMessages}
        wrapperCol={{ flex: 1 }}
        >
        <div style={{ display: 'flex', justifyContent: 'right' }}>
          <Form.Item>
            <Popconfirm
              placement="topLeft"
              title={translation('Sure to cancel?')}
              onConfirm={() => {
                props.navigate(-1);
              }}
              okText={translation('Yes')}
              cancelText={translation('No')}
            >
              <Button type='primary' style={{ marginRight: 8 }} theme={themeSettings} >
                {translation('Cancel')}
              </Button>
            </Popconfirm>
          </Form.Item>
          <Form.Item>
            <Button
              theme={themeSettings}
              type="primary"
              htmlType="submit"
              data-testid="submitButton"
            >
              {pathname.includes('RegisterModel')
                ? translation('Register')
                : translation('Submit')}
            </Button>
          </Form.Item>
        </div>
        <div style={{ display: 'flex', flexWrap: 'wrap' }}>
          <Form.Item
            label={translation('Model Name')}
            name="ModelName"
            rules={[{ required: true }]}
            style={formItemLayout}
          >
            <Input style={{ width: '70%' }} disabled type="text" />
          </Form.Item>
          <Form.Item
            label={translation('Description')}
            name="ModelDescription"
            rules={[{ required: true }]}
            style={formItemLayout}
          >
            <Input style={{ width: '70%' }} disabled />
          </Form.Item>
          <Form.Item
            label={translation('Model Group')}
            name="ModelGroup"
            rules={[{ required: true }]}
            style={formItemLayout}
          >
            <Input style={{ width: '70%' }} disabled />
          </Form.Item>
          <Form.Item
            label={translation('Model Type')}
            name="ModelType"
            rules={[{ required: true }]}
            style={formItemLayout}
          >
            <Input style={{ width: '70%' }} disabled />
          </Form.Item>
          <Form.Item
            label={translation('Target Parameter')}
            name="TargetParameter"
            rules={[{ required: true }]}
            style={formItemLayout}
          >
            <Input style={{ width: '70%' }} disabled />
          </Form.Item>
          <Form.Item
            label={translation('Target Parameter Type')}
            name="TargetParameterType"
            rules={[{ required: true }]}
            style={formItemLayout}
          >
            <Input style={{ width: '70%' }} disabled />
          </Form.Item>
          <Form.Item
            label={translation('Staging Source')}
            name="StagingAreaSourceId"
            rules={[{ required: true }]}
            style={formItemLayout}
          >
            <Input style={{ width: '70%' }} disabled />
          </Form.Item>
          <Form.Item
            label={translation('Staging Source Path')}
            name="StagingAreaSourcePath"
            rules={[{ required: true }]}
            style={formItemLayout}
          >
            <Input style={{ width: '70%' }} disabled />
          </Form.Item>
          <Form.Item
            label={translation('Registered By')}
            name="CreatedName"
            rules={[{ required: pathname.includes('RegisterModel') ? false : true }]}
            style={formItemLayout}
          >
            <Input style={{ width: '70%' }} disabled />
          </Form.Item>
          <Form.Item
            label={translation('Registered Date')}
            name="CreatedTime"
            rules={[{ required: pathname.includes('RegisterModel') ? false : true }]}
            style={formItemLayout}
          >
            <Input style={{ width: '70%' }} disabled />
          </Form.Item>
          <Form.Item
            label={translation('Status')}
            name="Status"
            rules={[{ required: true }]}
            style={formItemLayout}
          >
            <Input style={{ width: '70%' }} disabled />
          </Form.Item>
          <Form.Item
            label={translation('Enabled')}
            name="Enabled"
            valuePropName="checked"
            rules={[{ required: true }]}
            style={formItemLayout}
          >
            <Switch />
          </Form.Item>
          <Form.Item label={translation('Comments')} name="comments" style={formItemLayout}>
            <TextArea style={{ width: '70%' }} />
          </Form.Item>
          <Form.Item style={formItemLayout} label={translation('Drift')}>
            <Button
              type='primary'
              onClick={() =>
                props.navigate(`/rubus/RbsAnalytics/MonitorDrift?ModelId=${formObject.ModelId}`,
                  {
                    state: {
                      ModelName:
                        formObject && formObject['ModelName'] ? formObject['ModelName'] : '',
                      relatedTags: formObject.RelatedTagsList ? formObject.RelatedTagsList : [],
                      FromTime:
                        formObject && formObject.TrainPeriodFrom ? formObject.TrainPeriodFrom : '',
                      ToTime: formObject && formObject.TrainPeriodTo ? formObject.TrainPeriodTo : ''
                    }
                  })
              }
            >
              {translation('Calculate Drift')}
            </Button>
          </Form.Item>
          <Form.Item style={formItemLayout}></Form.Item>
        </div>
        {/* ======== (Details, Deployment History, Batch Prediction, RealTime Tabs)======== */}
        <StyledSubForm theme={themeSettings}>
          <Tabs
            type="card"
            onChange={() => {
              const pager = { ...pagination };               
              pager.current = 1;
              setPagination(pager);
            }}
            items={items01}
          />
        </StyledSubForm>
        </StyledForm>
        {/* ================== DeployMent History Deploy Form =========== */}
        <StyledModal
      width="700px"
      title={translation('Deploy Model')}
      open={deployModelVisible}
      onCancel={() =>  setDeployModelVisible(false) }
      closable
      theme={themeSettings}
      footer={[
        <>
          <Button 
            key="back"
            onClick={() => {
              modelDeployRef.current &&
                modelDeployRef.current.setFieldsValue({
                  SourceServer: '',
                  TargetServer: ''
                });
              setDeployModelVisible(false);
              setModelDeploymentInfo({});
            }}
          >
            {' '}
            {translation('Cancel')}{' '}
          </Button>
          <Button key="submit" type="primary" onClick={() => buttonRef.current.click()}>
          {' '}
          {translation('Submit')}{' '}
          </Button>
        </>
      ]}
    >
          {/* <div style={{ display: "flex", flexWrap: "wrap" }}> */}
      <StyledForm
        name="ModelDeployment"
        ref={modelDeployRef}
        autoComplete="off"
        initialValues={modelDeploymentInfo}
        theme={themeSettings}
        layout="horizontal"
        labelCol={{ flex: '200px' }}
        labelAlign="right"
        onFinish={onDeploySubmit}
        onFinishFailed={onFinishFailed}
        labelWrap
        validateMessages={validateMessages}
        wrapperCol={{ flex: 1 }}
      >
            {/* <Form.Item
              // label={translation('Virtual Environment')}
              name="Virtualenv"
              rules={[{ required: true }]}
              style={{ width: '600px', marginLeft: '100px' }}
            >
              <Input placeholder={translation('Input Virtual Environment')} />
            </Form.Item>
            <Form.Item label={translation('Default')} name="Default" valuePropName="checked">
              <Switch />
            </Form.Item> */}
        <Form.Item
          label={translation('Source Server')}
          name="SourceServer"
          rules={[{ required: true }]}
        >
          <Input
            placeholder={translation('Input Source Server')}
            style={{ width: '50%' }}
          />
        </Form.Item>
        <Form.Item
          label={translation('Target Server')}
          name="TargetServer"
          rules={[{ required: true }]}
        >
          <Input
            placeholder={translation('Input Target Server')}
            style={{ width: '50%' }}
          />
        </Form.Item>
        <Form.Item>
          <Button ref={buttonRef} htmlType="submit" style={{ display: 'none' }}></Button>
        </Form.Item>
      </StyledForm>
    </StyledModal>
        {/* ================ Batch Prediction NewRequest Form in Modal=========== */}
        <StyleModal
          title={translation('Prediction Request')}
          open={predictionModel}
          onCancel={() => {
            setPredictionRequestInfo({});
            setPredictionModel(false);
            predictionRequestRef.current &&
              predictionRequestRef.current.setFieldsValue({
                FromTime: null,
                ToTime: null
              });
          }}
          closable
          theme={themeSettings}
          footer={[
            <>
              <Button key="back" 
          onCancel={() => {
            setPredictionRequestInfo({});
            setPredictionModel(false);
            predictionRequestRef.current &&
              predictionRequestRef.current.setFieldsValue({
                FromTime: null,
                ToTime: null
              });
          }}
              >
                {predictionRequestInfo && predictionRequestInfo.PredReqId
                  ? translation('Close')
                  : translation('Cancel')}
              </Button>
              {predictionRequestInfo && predictionRequestInfo.PredReqId ? null : (
                <Button
                  key="submit"
                  type="primary"
                  onClick={() => predictionButtonRef.current && predictionButtonRef.current.click()}
                >
                  {translation('Submit')}
                </Button>
              )}
            </>
          ]}
          >
          <div style={{ width: '1300px' }}>
            <StyledForm
              name="Prediction Request"
              ref={predictionRequestRef}
              autoComplete="off"
              initialValues={predictionRequestInfo || {}}
              theme={themeSettings}
              layout="horizontal"
              labelCol={{ flex: '200px' }}
              labelAlign="right"
              onFinish={onPredictionRequestSubmit}
              onFinishFailed={onFinishFailed}
              labelWrap
              validateMessages={validateMessages}
              wrapperCol={{ flex: 1 }}
            >
              <StyledBox>
                <StyledBoxLabel>{translation('Deployment Details')}</StyledBoxLabel>
                <div style={{ display: 'flex', flexWrap: 'wrap', marginTop: '50px' }}>
                  <Form.Item
                    label={translation('Deployed Date')}
                    name="CreatedTime"
                    rules={[{ required: true }]}
                    style={formItemLayout}
                  >
                    <Input disabled style={{ width: '70%' }} />
                  </Form.Item>
                  <Form.Item
                    label={translation('Virtual Environment')}
                    name="Virtualenv"
                    rules={[{ required: true }]}
                    style={formItemLayout}
                  >
                    <Input disabled style={{ width: '70%' }} />
                  </Form.Item>
                </div>
              </StyledBox>
              <StyledBox>
                <StyledBoxLabel>{translation('Prediction Details')}</StyledBoxLabel>
                <div style={{ display: 'flex', flexWrap: 'wrap', marginTop: '50px' }}>
                  <Form.Item
                    label={translation('Train Period')}
                    name="TrainPeriodFrom"
                    rules={[{ required: true }]}
                    style={formItemLayout}
                  >
                    <Space.Compact>
                      <Form.Item name="TrainPeriodFrom" rules={[{ required: true }]}>
                        <Input style={{ textAlign: 'center', width: 190 }} disabled />
                      </Form.Item>
                      <Form.Item rules={[{ required: true }]}>
                        <Input
                          style={{
                            width: 50,
                            borderLeft: 0,
                            borderRight: 0,
                            pointerEvents: 'none'
                          }}
                          placeholder={translation('To')}
                          disabled
                        />
                      </Form.Item>
                      <Form.Item name="TrainPeriodTo" rules={[{ required: true }]}>
                        <Input
                          style={{
                            textAlign: 'center',
                            borderLeft: 0,
                            width: 190
                          }}
                          disabled
                        />
                      </Form.Item>
                    </Space.Compact>
                  </Form.Item>
                  <Form.Item
                    label={translation('Evaluation Period')}
                    name="EvalPeriodFrom"
                    rules={[{ required: true }]}
                    style={formItemLayout}
                  >
                    <Space.Compact>
                      <Form.Item name="EvalPeriodFrom">
                        <Input style={{ textAlign: 'center', width: 190 }} disabled />
                      </Form.Item>
                      <Form.Item rules={[{ required: true }]}>
                        <Input
                          style={{
                            width: 50,
                            borderLeft: 0,
                            borderRight: 0,
                            pointerEvents: 'none'
                          }}
                          placeholder={translation('To')}
                          disabled
                        />
                      </Form.Item>
                      <Form.Item name="EvalPeriodTo">
                        <Input
                          style={{
                            textAlign: 'center',
                            borderLeft: 0,
                            width: 190
                          }}
                          disabled
                        />
                      </Form.Item>
                    </Space.Compact>
                  </Form.Item>
                  <Form.Item
                    label={translation('Future Prediction')}
                    name="FuturePredRangeFrom"
                    rules={[{ required: true }]}
                    style={formItemLayout}
                  >
                    <Space.Compact>
                      <Form.Item name="FuturePredRangeFrom">
                        <Input style={{ textAlign: 'center', width: 85 }} disabled />
                      </Form.Item>
                      <Form.Item rules={[{ required: true }]}>
                        <Input
                          style={{
                            width: 50,
                            borderLeft: 0,
                            borderRight: 0,
                            pointerEvents: 'none'
                          }}
                          placeholder={translation('To')}
                          disabled
                        />
                      </Form.Item>
                      <Form.Item name="FuturePredRangeTo">
                        <Input
                          style={{
                            textAlign: 'center',
                            borderLeft: 0,
                            width: 85
                          }}
                          disabled
                        />
                      </Form.Item>
                      <Form.Item rules={[{ required: true }]}>
                        <Input
                          style={{
                            width: 100,
                            borderLeft: 0,
                            borderRight: 0,
                            pointerEvents: 'none'
                          }}
                          placeholder={translation('UOM')}
                          disabled
                        />
                      </Form.Item>
                      <Form.Item name="FuturePredRangeUom">
                        <Input
                          style={{
                            textAlign: 'center',
                            borderLeft: 0,
                            width: 110
                          }}
                          disabled
                        />
                      </Form.Item>
                    </Space.Compact>
                  </Form.Item>
                  <Form.Item
                    label={translation('Look back period')}
                    rules={[{ required: true }]}
                    style={formItemLayout}
                  >
                    <Space.Compact>
                      <Form.Item name="LookBackPeriod">
                        <Input style={{ textAlign: 'center', width: 200 }} disabled />
                      </Form.Item>
                      <Form.Item rules={[{ required: true }]}>
                        <Input
                          style={{
                            width: 100,
                            borderLeft: 0,
                            borderRight: 0,
                            pointerEvents: 'none'
                          }}
                          placeholder={translation('UOM')}
                          disabled
                        />
                      </Form.Item>
                      <Form.Item name="LookBackPeriodUom">
                        <Input
                          style={{
                            textAlign: 'center',
                            borderLeft: 0,
                            width: 130
                          }}
                          disabled
                        />
                      </Form.Item>
                    </Space.Compact>
                  </Form.Item>
                  <Form.Item
                    name="FromTime"
                    label={translation('From Time')}
                    rules={[{ required: true }]}
                    style={formItemLayout}
                  >
                    <DatePicker
                      showTime={{ format: "HH:mm:ss" }}
                      format="YYYY-MM-DD HH:mm:ss"
                      onChange={(date) => handleDateInputChange(date)}
                      disabledDate={(d) =>
                        !d ||
                        d.isAfter(
                          predictionRequestRef.current &&
                          predictionRequestRef.current.getFieldValue('ToTime')
                            ? dayjs(predictionRequestRef.current.getFieldValue('ToTime')).format('YYYY-MM-DD HH:mm:ss')
                            : ''
                        )
                      }
                    />
                  </Form.Item>
                  <Form.Item
                    name="ToTime"
                    label={translation('To Time')}
                    rules={[{ required: true }]}
                    style={formItemLayout}
                  >
                    <DatePicker
                      allowClear={false}
                      showTime={{ format: "HH:mm:ss" }}
                      format="YYYY-MM-DD HH:mm:ss"
                      onOk={(date) => handleDateInputChange(date)}
                      disabledDate={(d) =>
                        !d ||
                        d.isBefore(
                          predictionRequestRef.current &&
                          predictionRequestRef.current.getFieldValue('FromTime')
                            ? dayjs(predictionRequestRef.current.getFieldValue('FromTime')).subtract(1, 'day').format('YYYY-MM-DD HH:mm:ss')
                            : ''
                        )
                      }
                      disabledTime={(current) => {
                        let FromTime = predictionRequestRef.current && predictionRequestRef.current.getFieldValue('FromTime');
                        if (!FromTime || !current) {
                          return {};
                        }
                        const disabledHours = [];
                        const disabledMinutes = [];
                        const disabledSeconds = [];
                        if (current.isSame(FromTime, 'day')) {
                          for (let i = 0; i < FromTime.hour(); i++) {
                            disabledHours.push(i);
                          }
                          if (current.hour() === FromTime.hour()) {
                            for (let i = 0; i < FromTime.minute(); i++) {
                              disabledMinutes.push(i);
                            }
                            if (current.minute() === FromTime.minute()) {
                              for (let i = 0; i < FromTime.second(); i++) {
                                disabledSeconds.push(i);
                              }
                            }
                          }
                        }
                        return {
                          disabledHours: () => disabledHours,
                          disabledMinutes: () => disabledMinutes,
                          disabledSeconds: () => disabledSeconds
                        };
                      }}
                    />
                  </Form.Item>
                  <Form.Item
                    name="Metrics"
                    label={translation('Metrics')}
                    rules={[{ required: true }]}
                    style={formItemLayout}
                  >
                    <Tree
                      checkable
                      onCheck={(e) => onCheck('Metrics', e)}
                      switcherIcon={<DownOutlined />}
                      checkedKeys={
                        predictionRequestInfo && predictionRequestInfo['Metrics']
                          ? predictionRequestInfo['Metrics']
                          : ''
                      }
                    >
                      {renderTreeNodes(metricsData)}
                    </Tree>
                  </Form.Item>
                  <Form.Item>
                    <Button
                      ref={predictionButtonRef}
                      htmlType="submit"
                      style={{ display: 'none' }}
                    ></Button> </Form.Item>
                </div>
              </StyledBox>
            </StyledForm>
          </div>
          </StyleModal>
        {/* ============ Real Time Prediction Create Request Form =============== */}
        <StyleModal
          title={translation('Real Time Inference')}
          open={realTimeModel}
          onCancel={() => {
            setRealTimeInfo({});
            setRealTimeModel(false);
            setButtonKey(null);
            setSelectedCommunication([]);
            setMailRecipient([]);
        //    setAddCondition(false);
            setStatus('Inactive');
            // AddConditionFormDisable: true,
            // OnValueChangeDisable: true
            realTimeModelRef.current &&
              realTimeModelRef.current.setFieldsValue({
                FromTime: dayjs(),
                ToTime: null,
                DataSourceID: null,
                TargetServer: null,
                Frequency: null,
                Comments: null,
                // ModelType:'',
                Operator: null,
                Value: [],
                CommunicationTypes: [],
                MailRecipient: []
              });
          }}
          closable
          theme={themeSettings}
          footer={[
            <>
              <Button key="back" 
              onClick={() => {
              setRealTimeInfo({});
              setRealTimeModel(false);
              setButtonKey(null);
              setSelectedCommunication([]);
              setMailRecipient([]);
          //    setAddCondition(false);
              setStatus('Inactive');
              // AddConditionFormDisable: true,
              // OnValueChangeDisable: true
              realTimeModelRef.current &&
                realTimeModelRef.current.setFieldsValue({
                  FromTime: dayjs(),
                  ToTime: null,
                  DataSourceID: null,
                  TargetServer: null,
                  Frequency: null,
                  Comments: null,
                  // ModelType:'',
                  Operator: null,
                  Value: [],
                  CommunicationTypes: [],
                  MailRecipient: []
                });
              }}>
                {translation('Cancel')}
              </Button>
              {buttonKey === 'start' && (
                <Button key="Submit" type="primary" onClick={onRealTimeModelSubmit}>
                  {translation('Submit')}
                </Button>
              )}
              {buttonKey === 'edit' && (
                <Button key="Submit" type="primary" onClick={onRealTimeModelUpdate}>
                  {translation('Submit')}
                </Button>
              )}
              {/* {ButtonKey && ButtonKey === 'edit' ? (
                <Button key="CancelRequest" type="primary" onClick={onRealTimeModelReqCancel}>
                  {' '}
                  {translation('Cancel Request')}{' '}
                </Button>
              ) : null} */}
              {buttonKey === 'stop' && (
                <Button key="Submit" type="primary" onClick={onRealTimeModelStopJob}>
                  {translation('Submit')}
                </Button>
              )}
            </>
          ]}
          >
          <StyledForm
            className="RealTimeStartForm"
            name="Real Time Inference"
            ref={realTimeModelRef}
            autoComplete="off"
            initialValues={realTimeInfo || {}}
            theme={themeSettings}
            layout="horizontal"
            labelCol={{ flex: '200px' }}
            labelAlign="right"
            onFinish={onRealTimeModelSubmit}
            onFinishFailed={onFinishFailed}
            labelWrap
            validateMessages={validateMessages}
            wrapperCol={{ flex: 1 }}
          >
            <div style={{ display: 'flex', flexWrap: 'wrap', width: '1300px' }}>
              <Form.Item
                name="FromTime"
                label={translation('Start Time')}
                rules={[{ required: true }]}
                style={formItemLayout}
              >
                <DatePicker
                  style={{ width: '70%' }}
                  allowClear={false}
                  showTime={{ format: 'HH:mm:ss' }}
                  format="YYYY-MM-DD HH:mm:ss"
                  onOk={(date) => handleRealTimeDateInputChange(date)}
                  disabled={buttonKey === 'stop' || buttonKey === 'edit'}
                  disabledDate={(d) =>
                    !d ||
                    d.isAfter(
                      realTimeModelRef.current?.getFieldValue('ToTime')
                        ? dayjs(realTimeModelRef.current.getFieldValue('ToTime')).format('YYYY-MM-DD HH:mm:ss')
                        : ''
                    ) ||
                    d.isBefore(dayjs().format('YYYY-MM-DD HH:mm:ss'))
                  }
                />
              </Form.Item>
              <Form.Item name="ToTime" label={translation('End Time')} style={formItemLayout}>
                <DatePicker
                  style={{ width: '70%' }}
                  allowClear={false}
                  showTime={{ format: 'HH:mm:ss' }}
                  format="YYYY-MM-DD HH:mm:ss"
                  disabled={buttonKey === 'stop' ? true : false}
                  onOk={(date) => handleRealTimeDateInputChange(date)}
                  disabledDate={(d) =>
                    !d ||
                    d.isBefore(
                      realTimeModelRef.current?.getFieldValue('FromTime')
                        ? dayjs(realTimeModelRef.current.getFieldValue('FromTime')).format('YYYY-MM-DD HH:mm:ss')
                        : ''
                    ) &&
                    d.isBefore(dayjs().format('YYYY-MM-DD HH:mm:ss'))
                  }
                  disabledTime={(current) => {
                    let FromTime = realTimeModelRef.current?.getFieldValue('FromTime');
                    let currentTime = dayjs();
                    if (!FromTime || !current) {
                      return {};
                    }
                    const disabledHours = [];
                    const disabledMinutes = [];
                    const disabledSeconds = [];
                    if (current.isSame(FromTime, 'day')) {
                      for (let i = 0; i < FromTime.hour(); i++) {
                        disabledHours.push(i);
                      }
                      if (current.hour() === FromTime.hour()) {
                        for (let i = 0; i < FromTime.minute(); i++) {
                          disabledMinutes.push(i);
                        }
                        if (current.minute() === FromTime.minute()) {
                          for (let i = 0; i < FromTime.second(); i++) {
                            disabledSeconds.push(i);
                          }
                        }
                      }
                    }
                    if (current.isSame(currentTime, 'day')) {
                      for (let i = 0; i < currentTime.hour(); i++) {
                        disabledHours.push(i);
                      }
                      if (current.hour() === currentTime.hour()) {
                        for (let i = 0; i < currentTime.minute(); i++) {
                          disabledMinutes.push(i);
                        }
                        if (current.minute() === currentTime.minute()) {
                          for (let i = 0; i < currentTime.second(); i++) {
                            disabledSeconds.push(i);
                          }
                        }
                      }
                    }
                    return {
                      disabledHours: () => disabledHours,
                      disabledMinutes: () => disabledMinutes,
                      disabledSeconds: () => disabledSeconds
                    };
                  }}
                />
              </Form.Item>
              <Form.Item label={translation('DataSource')} name="DataSourceID" style={formItemLayout}>
                <Select
                  disabled={buttonKey === 'edit' || buttonKey === 'stop'}
                  style={{ width: '70%' }}
                  placeholder={translation('Please Select DataSource')}
                >
                  {dataSourceList && Array.isArray(dataSourceList) && dataSourceList.map((item, index) => (
                    <Option key={index} value={item.Id}>
                      {item.Name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item label={translation('Target Server')} name="TargetServer" style={formItemLayout}>
                <Select
                  disabled={buttonKey === 'edit' || buttonKey === 'stop'}
                  style={{ width: '70%' }}
                  placeholder={translation('Please Select Target Server')}
                >
                  {/* {DataSourceList &&
                    Array.isArray(DataSourceList) &&
                    DataSourceList.map((item, index) => {
                      return (
                        <Option key={index} value={item.Id}>
                          {item.Name}
                        </Option>
                      );
                    })} */}
                </Select>
              </Form.Item>
              <Form.Item label={translation('Frequency')} name="Frequency" style={formItemLayout}>
                <Select
                  disabled={buttonKey === 'edit' || buttonKey === 'stop'}
                  style={{ width: '70%' }}
                  placeholder={translation('Please Select Frequency')}
                >
                  {/* {DataSourceList &&
                    Array.isArray(DataSourceList) &&
                    DataSourceList.map((item, index) => {
                      return (
                        <Option key={index} value={item.Id}>
                          {item.Name}
                        </Option>
                      );
                    })} */}
                </Select>
              </Form.Item>
              <Form.Item label={translation('Comments')} name="Comments" style={formItemLayout}>
                <TextArea
                  disabled={buttonKey === 'edit' || buttonKey === 'stop'}
                  style={{ width: '70%' }}
                  placeholder={translation('Add Comments')}
                />
              </Form.Item>
              <StyledSubForm
                theme={themeSettings}
                style={{ background: 'rgb(8, 24, 70)', padding: '5px' }}
              >
                <Tabs
                  type="card"
                  className="ActionsTab"
                  // activeKey={predictionActiveKey}
                  // onChange={(value) => {
                  // }}
                  items={items02}
                />
              </StyledSubForm>
            </div>
          </StyledForm>
          </StyleModal>
        {/* =============== Batch Prediction Results Drawer =========== */}
        <Drawer
      title={translation('Inference Results')}
      placement={'right'}
      width="90%"
      onClose={() => {
        // trendRef.current &&
        // trendRef.current.resetFields();
        const pager = { ...pagination };
        pager.current = 1;
        setResultsDrawerVisible(false);
        setPredictionActiveKey('Metric values');
        setPagination(pager);
      }}
      open={resultsDrawerVisible}
      extra={
        <Space>
          <Button 
        onClick={() => {
        // trendRef.current &&
        // trendRef.current.resetFields();
        const pager = { ...pagination };
        pager.current = 1;
        setResultsDrawerVisible(false);
        setPredictionActiveKey('Metric values');
        setPagination(pager);
        }}
          >
            {translation('Cancel')}
          </Button>
              {/* <Button type="primary">OK</Button> */}
        </Space>
      }
    >
          {/* <StyledSubForm theme={themeSettings}> */}
      <Tabs
        type="card"
        activeKey={predictionActiveKey}
        onChange={(value) => {
          if (value === 'Functional summary') {
            getDailyFunctionalSummary(
              functionalSummaryDailyFrom,
              functionalSummaryDailyTo
            );
            getweeklyFunctionalSummary(
              functionalSummaryWeeklyTo,
              functionalSummaryWeekCount
            );
          }
          let trendObj = trendRef.current && trendRef.current.getFieldsValue();
          let toDate = dayjs(predictionReqInfo.FromTime)
            .utc()
            .add(1, 'hours')
            .format('YYYY-MM-DD HH:mm:ss');
          let defaultParameter = [];
          parameterList &&
            parameterList !== undefined &&
            Array.isArray(parameterList) &&
            parameterList.map((item, index) => {
              if (index < 5) {
                defaultParameter.push(item.parameterCode);
              }
            });
          trendObj = {
            // ...trendObj,
            DeviceCode:
              deviceList && deviceList[0] && deviceList[0]['Device']
                ? [deviceList[0]['Device']]
                : [],
            ParameterCode: defaultParameter,
            FromDate: dayjs.utc(predictionReqInfo.FromTime, 'YYYY-MM-DD HH:mm:ss').local(),
            ToDate: dayjs.utc(toDate, 'YYYY-MM-DD HH:mm:ss').local(),
            Interval:
              intervalData && intervalData[0] && intervalData[0]['value']
                ? intervalData[0]['value']
                : ''
          };
          onParameterChange(defaultParameter);
          trendRef.current && trendRef.current.setFieldsValue(trendObj);
          setPredictionActiveKey(value);
          setTrendObj(trendObj);
          setTrendData([]);
        }}
        items={items03}
      >
        <div
          key={0}
          style={{
            width: '48%',
            height: '48vh',
            marginTop: '1%'
          }}
        >
          {dailyFunctionalSummary && Array.isArray(dailyFunctionalSummary) && dailyFunctionalSummary.length > 0 ? (
            <FunctionalSummary
              panelData={{
                graph: 'trends',
                trendData: dailyFunctionalSummary,
                linetype: '',
                //update: update,
                type: 'bar',
                formObject: formObject
              }}
            />
          ) : null}
        </div>
        <Row>
          <Col span={11}>
            <Title level={4} style={{  width: '800px' }}>
              {'Main stream temperature(>428) weekly Anomaly count- Predicted Vs Actual(%)'}
            </Title>
          </Col>
          <Col span={4}></Col>
          <Col span={9}>
            <Form.Item label={translation('As On Date')}>
              <Space.Compact>
                <DatePicker
                  disabledDate={(d) =>
                    !d ||
                    d.isAfter(predictionToTime ? dayjs(predictionToTime).add(1, 'day').format('YYYY-MM-DD') : '') ||
                    d.isBefore(predictionFromTime ? dayjs(predictionFromTime).format('YYYY-MM-DD') : '')
                  }
                  value={dayjs(functionalSummaryWeeklyTo, 'YYYY-MM-DD HH:mm:ss')}
                  onChange={(date) =>
                    getweeklyFunctionalSummary(dayjs(date).utc().local().format('YYYY-MM-DD 23:59:59'), functionalSummaryWeekCount)
                  }
                  allowClear={false}
                />
                <Form.Item rules={[{ required: true }]}>
                  <Input
                    style={{
                      width: 100,
                      borderLeft: 0,
                      borderRight: 0,
                      pointerEvents: 'none'
                    }}
                    placeholder={translation('Last')}
                    disabled
                  />
                </Form.Item>
                <InputNumber
                  onChange={(value) =>
                    getweeklyFunctionalSummary(functionalSummaryWeeklyTo, value)
                  }
                  value={functionalSummaryWeekCount}
                />
                <Form.Item rules={[{ required: true }]}>
                  <Input
                    style={{
                      width: 80,
                      borderLeft: 0,
                      borderRight: 0,
                      pointerEvents: 'none'
                    }}
                    placeholder={translation('Weeks')}
                    disabled
                  />
                </Form.Item>
              </Space.Compact>
            </Form.Item>
          </Col>
        </Row>
        <div
          key={1}
          style={{
            width: '48%',
            height: '48vh',
            marginTop: '1%'
          }}
        >
          {weeklyFunctionalSummary && Array.isArray(weeklyFunctionalSummary) && weeklyFunctionalSummary.length > 0 ? (
            <FunctionalSummary
              panelData={{
                graph: 'trends',
                trendData: weeklyFunctionalSummary,
                linetype: '',
                //update: update,
                type: 'bar',
                formObject: formObject
              }}
            />
          ) : null}
        </div>
      </Tabs>
    </Drawer>
        {/*============ QuickRun Results Drawer=========== */}
        <StyledModal
            title={translation('Quick Run Results')}
            open={realTimeQuickRunResultDrawer}
            onCancel={() => {
              quickRunResultsRef.current &&
                quickRunResultsRef.current.setFieldsValue({
                  ActualValue: null,
                  PredictedValue: null
                });
              setRealTimeQuickRunResultDrawer(false);
              setQuickRunInfo({});
            }}
            closable
            theme={themeSettings}
            footer={[
              <Button
                key="cancel"
                onClick={() => {
                  quickRunResultsRef.current &&
                    quickRunResultsRef.current.setFieldsValue({
                      ActualValue: null,
                      PredictedValue: null
                    });
                  setRealTimeQuickRunResultDrawer(false);
                  setQuickRunInfo({});
                }
                }
              >
                {translation('Cancel')}
              </Button>
            ]}
            >
            <StyledForm
              name="QuickRunForm"
              autoComplete="off"
              initialValues={quickRunInfo}
              ref={quickRunResultsRef}
              theme={themeSettings}
              labelAlign=''
            >
              <div>
                <Form.Item
                  {...QuickRunItemLayout}
                  name="ActualValue"
                  label={translation('Actual Value')}
                >
                  <Input
                    style={{
                      width: '100%',
                      pointerEvents: 'none'
                    }}
                    disabled
                  />
                </Form.Item>
                <Form.Item
                  name="PredictedValue"
                  label={translation('Prediction Value')}
                  {...QuickRunItemLayout}
                >
                  <Input
                    style={{
                      width: '100%',
                      pointerEvents: 'none'
                    }}
                    disabled
                  />
                </Form.Item>
              </div>
            </StyledForm>
            </StyledModal>
        {/* ==============QuickRun DataSource selection Form ============ */}
        <StyledModal
          width="50%"
          title={translation('Quick Run')}
          open={quickRunModal}
          onCancel={() => {
            setQuickRunModal(false);
          }}
          closable
          theme={themeSettings}
          footer={[
            <>
              <Button key="back" 
              onClick={() => {
                quickRunModalRef.current &&
                  quickRunModalRef.current.setFieldsValue({
                    DataSourceID: null
                  });
                setQuickRunModal(false);
                setDataSourceId(null);
              }}
              >
                {translation('Cancel')}
              </Button>
              <Button key="Submit" type="primary" onClick={quickRun}>
                {translation('Submit')}
              </Button>
            </>
          ]}
          >
          <StyledForm
            name="QuickRun"
            autoComplete="off"
            ref={quickRunModalRef}
            theme={themeSettings}
            layout="horizontal"
            labelCol={{ flex: '200px' }}
            labelAlign="right"
            onFinish={quickRun}
            onFinishFailed={onFinishFailed}
            labelWrap
            validateMessages={validateMessages}
            wrapperCol={{ flex: 1 }}
          >
            <div style={{ display: 'flex', flexWrap: 'wrap' }}>
              <Form.Item
                label={translation('DataSource')}
                name="DataSourceID"
                style={formItemLayout}
              >
                <Select
                  value={dataSourceId}
                  style={{ width: '70%' }}
                  placeholder={translation('Please Select DataSource')}
                  onChange={onDataSourceChange}
                >
                  {dataSourceList && Array.isArray(dataSourceList) && dataSourceList.map((item, index) => (
                    <Option key={index} value={item.Id}>
                      {item.Name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </div>
          </StyledForm>
          </StyledModal>
        {/* ============== Real Time Results Drawer ========== */}
        <Drawer
          title={translation('Real Time Inference Results')}
          placement={'right'}
          width="90%"
          onClose={() => {
            const pager = { ...pagination };
            pager.current = 1;
            realTimePredictionRequestRef.current &&
              realTimePredictionRequestRef.current.setFieldsValue({
                FromTime: null,
                ToTime: null,
                Metrics: null
              });
            setRealTimeResultsDrawerVisible(false);
            setPredictionActiveKey('Metric values');
            setPagination(pager);
            setRealTimePredictionRequestInfo({});
            setOption({});
            setRocCurveOption({});
         //   setROCCurveData([]);
            setConfMatrixVisible(false);
            setROCCurveVisible(false);
            setMetricValuesData1([]);
            setRealTimeMetricResultVisible(false);
          }}
          open={realTimeResultsDrawerVisible}
          extra={
            <Space>
              <Button 
                onClick={() => {
                  const pager = { ...pagination };
                  pager.current = 1;
                  realTimePredictionRequestRef.current &&
                    realTimePredictionRequestRef.current.setFieldsValue({
                      FromTime: null,
                      ToTime: null,
                      Metrics: null
                    });
                    setRealTimeResultsDrawerVisible(false);
                    setPredictionActiveKey('Metric values');
                    setPagination(pager);
                    setRealTimePredictionRequestInfo({});
                    //setMetricResultVisible(false),
                    setOption({});
                    setRocCurveOption({});
                   // setROCCurveData([]);
                    setConfMatrixVisible(false);
                    setROCCurveVisible(false);
                    setMetricValuesData1([]);
                    setRealTimeMetricResultVisible(false);
                }}              
              >
                {translation('Cancel')}
              </Button>
            </Space>
          }
          >
          {/* <StyledSubForm theme={themeSettings}> */}
            <Tabs
              type="card"
              activeKey={predictionActiveKey}
              onChange={(value) => {
                if (value === 'Functional summary') {
                  getRealTimeDailyFunctionalSummary(
                    functionalSummaryDailyFrom1,
                    functionalSummaryDailyTo1
                  );
                  getRealTimeweeklyFunctionalSummary(
                    functionalSummaryWeeklyTo1,
                    functionalSummaryWeekCount1
                  );
                  getRealTimeFunctionalSummary(
                    momentRange[0],
                    momentRange[1]
                  );
                }
                let trendObj =
                  realTimeTrendRef.current && realTimeTrendRef.current.getFieldsValue();
                let toDate = dayjs(realTimePredictionReqInfo.FromTime)
                  .utc()
                  .add(1, 'hours')
                  .format('YYYY-MM-DD HH:mm:ss');
                let defaultParameter = [];
                parameterList &&
                  parameterList !== undefined &&
                  Array.isArray(parameterList) &&
                  parameterList.map((item, index) => {
                    if (index < 5) {
                      defaultParameter.push(item.parameterCode);
                    }
                  });
                trendObj = {
                  // ...trendObj,
                  DeviceCode:
                    deviceList && deviceList[0] && deviceList[0]['Device']
                      ? [deviceList[0]['Device']]
                      : [],
                  ParameterCode: defaultParameter,
                  FromDate: dayjs
                    .utc(realTimePredictionReqInfo.FromTime, 'YYYY-MM-DD HH:mm:ss')
                    .local(),
                  ToDate: dayjs.utc(toDate, 'YYYY-MM-DD HH:mm:ss').local(),
                  Interval:
                    intervalData && intervalData[0] && intervalData[0]['value']
                      ? intervalData[0]['value']
                      : ''
                };
                onParameterChange(defaultParameter);
                realTimeTrendRef.current &&
                  realTimeTrendRef.current.setFieldsValue(trendObj);
                setPredictionActiveKey(value);
                setTrendObj(trendObj);
                setTrendData([]);
              }}
              items={items04}
            />
          {/* </StyledSubForm> */}
          </Drawer>
      </ >
    );
};
const mapStateToProps = (state) => ({
  userProfile: state.LayoutReducer.loggedInProfile,
  translationCache: state.TranslationReducer.translationCache
});
export default connect(mapStateToProps)(ModelDetails);
